var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 213.84,
    height: 220.432,
    viewBox: "0 0 213.84 220.432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5354",
    "data-name": "Rectangle 5354",
    width: 183.372,
    height: 191.5,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9801",
    "data-name": "Group 9801",
    transform: "matrix(-0.985, 0.174, -0.174, -0.985, 203.84, 195.59)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9800",
    "data-name": "Group 9800",
    transform: "translate(-11.064 5.157)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28093",
    "data-name": "Path 28093",
    d: "M14.818.883c-2.279.174-4.552.437-6.815.741-2.429.326-11.477-6.2-6.563,4.816A8.486,8.486,0,0,0,2.806,8.13C5.991,10.355,9.594,10.118,13.2,9.9c9.5-.582,19-1.127,28.49-1.748C47.049,7.8,52.4,7.327,57.758,6.909c-1.483-1.455-3.378-.944-5.125-1.017-1.657-.069-3.148-.282-4.1-1.866a2.58,2.58,0,0,0-2.373-1.31c-4.736.018-9.473.01-12.984.008,4.342.313,9.916-.6,15.473.473a11.469,11.469,0,0,0,5.044-.112c.71-.184,1.772-.342,1.174-1.6-.7-1.461-6.271-.755-7.46-.756L38.142.726C32.616.726,27.081.782,21.57.671c-2.254-.045-4.505.04-6.752.212",
    transform: "translate(28.232 181.466)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28094",
    "data-name": "Path 28094",
    d: "M24.794,3.12c-1.011,1.181-2.379.658-3.584.666-7.069.05-14.138.025-21.21.661,4.741,0,9.483.051,14.222-.027,1.758-.029,3.162.179,3.575,2.215.3,1.476,1.43,1.636,2.681,1.633,2.331-.006,4.663.034,6.995.055C37.507,7.8,47.54,7.284,57.571,6.732c5.809-.319,11.615-.692,17.422-1.067,1.146-.074,2.346.133,3.409-.518-2.615-.339-5.494.652-8.225-1.97,2.755,0,5.061.092,7.356-.028,2.014-.105,3.278-.888,1.9-3.149-1.795,1.6-3.968,1.676-6.215,1.631q-3.938-.08-7.883-.018c-2.669.084-5.356-.319-8,.319-1.96.83-3.988.493-5.961.192-5.278-.806-10.569-.539-15.865-.408a26,26,0,0,1-6.844.593c-1.332,0-2.751-.258-3.873.811",
    transform: "translate(58.516 180.051)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28095",
    "data-name": "Path 28095",
    d: "M25.461,5.822C26.151,3.938,27.3,2.158,26.771,0c-2.186.824-3.131,2.949-4.31,4.62-1.6,2.261-3.738,2.91-5.717,1.926-3.08-1.532-5.415-.274-7.953.919-.536,2.685-2.585,3.313-4.9,3.584a2.573,2.573,0,0,0-1.044.958A24.671,24.671,0,0,1,0,20.41c0,.209.008.419.015.628,1.685,1.1,3.379.156,5.07.023a12.88,12.88,0,0,0,5.132-2.548,6.645,6.645,0,0,0,2.733-5.928c-.088-1.678.563-2.833,2.483-2.793,3.7-.43,7.787.129,10.027-3.971",
    transform: "translate(156.465 159.036)",
    fill: "#871f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28096",
    "data-name": "Path 28096",
    d: "M7.656.023,2.586,0C1.646.75.468,1.254,0,2.494L7.656.023",
    transform: "translate(153.894 180.073)",
    fill: "#ecccbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28097",
    "data-name": "Path 28097",
    d: "M120.444,144.383c-1.031,8.464-1.7,16.967-2.819,25.412-.477,3.614.025,7.406-1.85,10.784-1.234,2.223-6.417.764-8.325.6q-5.549-.488-11.1-1.006c-28.509-2.659-57.112-5.557-85.443-9.755-1.864-.252-11.4-.29-10.892-3.51C2.3,152.529,3.35,137.85,4.976,123.383q2.508-22.321,5.016-44.642c.589-5.24,1.063-10.506,1.617-15.731q3-28.276,6.021-56.553a10.251,10.251,0,0,1,1.292-4.7C20.583-.709,23.828.087,26.342.259,30.1.513,33.776,1.474,37.55,1.5c5.263.643,10.546,1.165,15.8,1.877a19.4,19.4,0,0,1,3.271.28c3.3.757,6.8.286,10,1.655-.789,2.3-1.846,2.921-4.69,2.406-1.572-.286-2.978-.369-3.946,1.139-1.209,1.884-.77,9.3.993,10.609,2.921,2.17,5.231,4.92,7.847,7.376a4.968,4.968,0,0,0,3.488,1.343c3.22-.019,5.1,1.661,6.116,4.576a6.413,6.413,0,0,0,3.271,3.729,11.372,11.372,0,0,1,4.1,3.449c3.278,4.493,7.79,6.269,13.238,6.122,3.074-.083,6.148.019,9.222-.025a29.267,29.267,0,0,1,9.037,1.648c1.973.6,3.863,1.757,3.57,4.232-.337,2.819-2.737,2.011-4.525,2.177-.42.038.108-.013-.318-.019a7.89,7.89,0,0,1-1.489-.235,15.841,15.841,0,0,0-4.379-.42,8.171,8.171,0,0,1-1.464-.242c-1.757-.566-3.583-.21-5.365-.439a5.479,5.479,0,0,1-.961-.2c-1.566-.535-3.208-.255-4.8-.452a6.051,6.051,0,0,1-.955-.2,16.262,16.262,0,0,0-4.264-.388,8.344,8.344,0,0,1-1.426-.242,16.617,16.617,0,0,0-4.27-.395,8.4,8.4,0,0,1-1.432-.235c-1.4-.484-2.87-.28-4.3-.465a6.282,6.282,0,0,1-.961-.2,15.061,15.061,0,0,0-4.4-.293c-1.286-.019-2.571.019-3.85-.045l-.146-.038a9.7,9.7,0,0,0-1.356-.146,4.877,4.877,0,0,0,.751.134c.248.019.5.038.751.051a18.028,18.028,0,0,0,3.927.242c9.7,1.254,19.424,2.266,29.142,3.348a15.022,15.022,0,0,0,4.792.477c2.6.675,5.371.242,7.917,1.266,4.627,1.769,4.83,2.3,2.011,5.142-3.659,1.247-7.223-.757-10.857-.312a6,6,0,0,1-1.063-.191c-1.687-.617-3.462-.286-5.187-.5a6.349,6.349,0,0,1-1.044-.229c-9.056-.891-18.094-1.992-27.124-3.106-1.521-.439-3.106-.267-4.646-.547-.509-.051-1.018-.064-1.527-.146a43.705,43.705,0,0,0-5.467-.554,5.136,5.136,0,0,1-.986-.153c-1.795-.312-3.615-.344-5.416-.541a16.189,16.189,0,0,0-3.793-.414,15.709,15.709,0,0,1-1.782-.344c-.388-.191-.8-.3-1.2-.509a6.3,6.3,0,0,0,2.654.9c1.674.325,3.373.286,5.06.465a5.812,5.812,0,0,1,.936.134c1.394.395,2.858.223,4.27.477a9.879,9.879,0,0,1,1.432.121,16.976,16.976,0,0,0,3.761.4c.63.14,1.273.115,1.909.223a11.51,11.51,0,0,0,3.329.35c1.457.242,2.978.134,4.366.789A9.342,9.342,0,0,0,79,56.894a7.536,7.536,0,0,1,2.024.344c3.653,1.381,2.425,4.5,2.387,7.064-.032,2.361-1.648,3.488-3.908,3.819-1.126.159-2.514.248-2.495,1.833.019,1.464,1.419,1.247,2.355,1.61a38.479,38.479,0,0,0,12.073,3.055c2.476.134,5.009.535,7.516.815,1.489.165,2.686.878,2.616,2.6a2.678,2.678,0,0,1-2.584,2.711,8.023,8.023,0,0,1-2.208-.019,5.768,5.768,0,0,1-.98-.229c-2.412.006-4.328-2.355-6.912-1.464a15.009,15.009,0,0,1-4.99.5,9.581,9.581,0,0,1-1.9-.261A12.125,12.125,0,0,0,78.23,78.9a10,10,0,0,1-1.9-.261,16.527,16.527,0,0,0-3.742-.484,7.785,7.785,0,0,1-.929-.2,16.588,16.588,0,0,0-4.232-.369A8.894,8.894,0,0,1,66,77.342a16.766,16.766,0,0,0-4.328-.382,8.944,8.944,0,0,1-1.477-.248,14.426,14.426,0,0,0-4.525-.286c-.325.006-.656.013-.98.013-1.451-.191-2.966-.191-4.442-.3a13.157,13.157,0,0,0-3.959-.4c-.344-.318-.961-.191-1.489-.216a8.34,8.34,0,0,0,.916.191c.191.013.382.019.573.025a.088.088,0,0,1,.025.019c1.254.337,2.565.07,3.819.375.038,0,.076.006.115.006a1.1,1.1,0,0,1,.134.045,22.72,22.72,0,0,0,4.309.255,11.861,11.861,0,0,1,1.343.242c2.889.694,6.148-.35,8.694,1.846,1.19,3.087.636,4.016-2.539,4.226-.942.064-1.89.032-2.838.045a7.994,7.994,0,0,1-1.1.038q-2.215-.267-4.442-.484c-1.585-.286-3.188-.318-4.786-.484a4.613,4.613,0,0,1-.936-.14,24.318,24.318,0,0,0-3.615-.477c-.223.07-.165.121.134.159a2.5,2.5,0,0,1,.522.127c1.05.21,2.145.089,3.195.337,1.827.146,3.659.3,5.486.477.21.045.42.083.63.134,1.273.07,2.533.325,3.812.35.649.07,1.3.153,1.947.235,4.34.56,8.776.56,13.015,1.852,2.234.885,2.463,2.52,1.96,4.652-1.139,4.856-2.177,9.744.286,14.561.77,1.5-.305,1.814-1.47,1.967a4.211,4.211,0,0,1-1.056-.127c-1.75-.516-3.539-.242-5.308-.293a42.039,42.039,0,0,1-4.735-.153c-9.069-1.158-18.151-2.164-27.239-3.163a7.141,7.141,0,0,0-2.355-.318c-.885-.146-1.769-.274-2.654-.356a6.128,6.128,0,0,0-.681-.134,9.8,9.8,0,0,0-1.432-.115h-.146a18.621,18.621,0,0,0-3.717-.293c-.286-.019-.579-.07-.872-.1a1.716,1.716,0,0,0,.42.2,23.4,23.4,0,0,0,4.169.185c.172.032.337.076.5.121.586.025,1.171.07,1.757.127a2.192,2.192,0,0,1,.293.076,7.9,7.9,0,0,0,2.361.28c.261.051.522.1.783.146l1.572.172a3.412,3.412,0,0,1,1.165.726c.484.56,1.082,1.025,1.54,1.578.936,1.139,3.672,1.088,2.953,3.055-.675,1.814-2.985.9-4.589,1.146-.885,0-1.769-.051-2.654-.121,7.313.808,14.606,1.744,21.925,2.431,2.068.713,4.372.013,6.371,1.12a10.06,10.06,0,0,0,1.763.643c1.286.293,2.075,1.031,1.827,2.444-.216,1.279-1.241,1.617-2.336,1.655-3.138.1-6.212-.91-9.368-.528-3.354-.127-6.689-.433-9.966-.8,2.094.274,4.2.579,6.307.936a8.376,8.376,0,0,0,3.029.713,99.349,99.349,0,0,1,14.014,2.883c.878.28,1.973.675,1.852,1.827-.121,1.171-1.26,1.254-2.2,1.349-1.044.108-2.094.064-3.144.089a28.948,28.948,0,0,1-5.352-.229c-1.642-.6-3.367-.382-5.053-.547a5.209,5.209,0,0,1-.986-.2,12.1,12.1,0,0,0-3.85-.388,8.852,8.852,0,0,1-1.954-.261,12.191,12.191,0,0,0-3.392-.363c-6.415-.713-12.824-1.5-18.666-2.107,5.359.745,11.322,1.241,17.26,2.011a2.923,2.923,0,0,1,.9.375c1.61,1.063,3.449.395,5.161.719a6.143,6.143,0,0,1,.961.2c1.623.528,3.322.2,4.97.433a5.578,5.578,0,0,1,1.018.216c2.609.325,5.193.891,7.834,1.012.942.038,2.056.235,2.107,1.464a2.025,2.025,0,0,1-1.954,2.126c-1.947.235-3.939.891-5.823-.452a6.638,6.638,0,0,0-5.219-.706,49.061,49.061,0,0,1-7.892.5c-1.209,0-2.418-.057-3.621-.146-.1-.019-.185-.038-.274-.064-1.082.006-2.189-.318-3.271-.274-1.623-.191-3.246-.414-4.862-.636-1.025-.178-2.056-.305-3.087-.4-1.916-.235-3.838-.426-5.766-.509a2.274,2.274,0,0,1-1.3-.375c.6,1.527,1.979.286,2.915.63q2.081.067,4.156.255c1.031.127,2.056.261,3.087.4,1.025.159,2.037.369,3.042.624.191.089.382.185.573.274a3.448,3.448,0,0,1,1.247-.261c1.177.134,2.361.255,3.545.337a29.845,29.845,0,0,0,4.824.4,6.445,6.445,0,0,1,.986.2,9.585,9.585,0,0,0,3.341.382,10.4,10.4,0,0,1,2.431.28,17.257,17.257,0,0,0,4.391.382,8.473,8.473,0,0,1,1.489.255,14.1,14.1,0,0,0,4.1.318c8.013.916,16.012,1.941,24.038,2.718,1.718.636,3.526.382,5.282.554a5.917,5.917,0,0,1,1.05.216c1.006.375,2.094.134,3.087.363,3.131.738,6.472,0,9.489,1.432a8.964,8.964,0,0,0,7.083,3.278c2.062.051,4,1.152,6.116,1.292,1.394.1,1.941,1.063,2.126,2.31a11.713,11.713,0,0,1,.025,2.832M57.19,48.239c1.534.566,3.163.235,4.735.509a9.629,9.629,0,0,0,.961.089,4.817,4.817,0,0,1,.948.146c1.387.452,2.858.172,4.258.458.038,0,.07.006.108.006-.083-.019-.165-.045-.248-.07-1.629-.624-3.411-.1-5.047-.668a1.607,1.607,0,0,1-.757-.681.9.9,0,0,1,.038-.375h-.076a1.788,1.788,0,0,1-1.375.3,31.924,31.924,0,0,0-4.741-.267,8.26,8.26,0,0,1-1.419-.235,14.623,14.623,0,0,0-4.207-.363,9.278,9.278,0,0,1-1.827-.248c-.713-.025-1.432-.8-2.183-.013,3.526.961,7.211.929,10.832,1.413M44.8,75.522a1.49,1.49,0,0,1-.853-.579.8.8,0,0,0,.853.579m-.859-.592a2.057,2.057,0,0,1-.045-.6c.032-.025.07-.051.108-.076-.032,0-.07-.006-.1-.006,0,.025-.006.057-.006.083l-.172.134a1.5,1.5,0,0,0,.216.465M40.057,55.678a1.786,1.786,0,0,1,.458-.967,3.059,3.059,0,0,0-.242-.267,4.565,4.565,0,0,1-.42-1.877,13.958,13.958,0,0,1,.255-3.85c.134-.942,1.566-1.566.687-2.756a4.15,4.15,0,0,1-.687-.312c-1.438-.808-3.048-.337-4.563-.611a6.757,6.757,0,0,1-.866-.185c-1.457-.465-2.978-.223-4.468-.363-1.712-.726-2.749.509-3.92,1.349a.459.459,0,0,1-.127-.057c1.292,1.807.573,3.908.783,5.881a31.289,31.289,0,0,0,.159,4.086c.337,1.006,1.171,1.1,2.037,1.095,2.845-.025,5.607.694,8.426.885,1.114.165,1.877,1.152,3.055,1.47.006-1.356-.846-2.348-.566-3.519m-12.7,31.007a.682.682,0,0,1,.064.14c.045-.006.089-.019.134-.025a13.142,13.142,0,0,1,4.646.325c.134.127.255.248.375.376a1.89,1.89,0,0,1,1.4-.535,3.666,3.666,0,0,1,.91.14,1.843,1.843,0,0,1,1.006.84c.56.445.541,1.992,1.871,1.012-.038-1.763-1.158-3.3-1.107-5.091a22.51,22.51,0,0,1,.458-5.982c.414-1.693-.1-2.756-2.068-3.068-1.578-.255-3.15-.235-4.729-.375-5.391-.477-5.263-.452-6.084,4.932-.5,3.227-1.2,6.269,3.125,7.313m3.92,21.766c.9.108,1.807.216,2.711.293-.9-.1-1.807-.2-2.711-.293m8,6.651c1.617.21,3.259.414,4.913.6-1.648-.216-3.29-.407-4.913-.6-4.487-.573-8.827-1.165-12.932-1.5,4.022.56,8.407.993,12.932,1.5m-8.172-6.67c-1.744-.216-3.494-.439-5.251-.522q2.625.239,5.251.522m3.526,32.82h-.006c-.172.019-.312.038-.083.28a.774.774,0,0,1,.083.089c-.025.013.032.057,0,0,.019-.019.07-.019.2.013.2.051.4.1.6.134a1.758,1.758,0,0,1-.8-.516m.8.516a7.6,7.6,0,0,0,1.884.2c-.624-.051-1.26-.1-1.884-.2m10.38,1.107a17.834,17.834,0,0,0-2.921-.312q-2.625-.277-5.251-.566l-.242-.019a12.7,12.7,0,0,1,1.489.21,24.02,24.02,0,0,0,4,.375c.974.108,1.947.21,2.921.312a8.165,8.165,0,0,1,2.336.859.349.349,0,0,0,.045.057,3.524,3.524,0,0,1,2.227-.42l-4.608-.5m23.4,2.546c-3.609-.522-7.243-.878-10.877-1.19q-3.828-.43-7.656-.834l.248.038c2.368.375,4.76.445,7.128.808a10.456,10.456,0,0,1,1.088.089c1.521.49,3.125.172,4.665.516,6.663.694,13.314,1.508,19.971,2.24-4.856-.566-9.706-1.209-14.568-1.667",
    transform: "translate(0 2.087)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28098",
    "data-name": "Path 28098",
    d: "M3.087.4C2.062.223,1.031.1,0,0,1.031.127,2.056.261,3.087.4",
    transform: "translate(29.092 127.887)",
    fill: "#f4fdfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28099",
    "data-name": "Path 28099",
    d: "M.007,0c-.025.013.032.057,0,0",
    transform: "translate(34.622 143.709)",
    fill: "#f4fdfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28100",
    "data-name": "Path 28100",
    d: "M1.884.2C1.26.153.624.108,0,0A7.6,7.6,0,0,0,1.884.2",
    transform: "translate(35.437 143.855)",
    fill: "#f4fdfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28101",
    "data-name": "Path 28101",
    d: "M2.921.312A17.835,17.835,0,0,0,0,0C.974.108,1.947.21,2.921.312",
    transform: "translate(42.896 144.651)",
    fill: "#f4fdfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28102",
    "data-name": "Path 28102",
    d: "M2.259.248A6.128,6.128,0,0,0,1.578.115,9.8,9.8,0,0,0,.146,0H0C.172.032.337.076.5.121c.586.025,1.171.07,1.757.127",
    transform: "translate(28.385 103.531)",
    fill: "#f0fcfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28103",
    "data-name": "Path 28103",
    d: "M2.711.293C1.807.191.9.089,0,0,.9.108,1.807.216,2.711.293",
    transform: "translate(31.281 110.538)",
    fill: "#f0fcfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28104",
    "data-name": "Path 28104",
    d: "M2.355.318A7.141,7.141,0,0,0,0,0C.261.051.522.1.783.146L2.355.318",
    transform: "translate(33.298 104.136)",
    fill: "#f0fcfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28105",
    "data-name": "Path 28105",
    d: "M4.913.6C3.265.382,1.623.191,0,0,1.617.21,3.259.414,4.913.6",
    transform: "translate(39.281 117.189)",
    fill: "#f0fcfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28106",
    "data-name": "Path 28106",
    d: "M61.962,7.266c3.312-.037,6.836.214,10.114-.3.5-.078,1.322-.631.612-1.114-1.44-.979-3.014-.423-4.54-.395-1.385,0-2.84.57-4.111-.479-1.713-.31-3.519.057-5.162-.744Q47.807,3.415,36.758,2.455C26.429,1.545,16.078.908,5.743.077c-1.443-.115-3-.266-4.211.9-1.1,1.064-1.687,1.758-1.5,3.4C.2,5.8-.079,7.341,1.6,7.887A6.054,6.054,0,0,0,3.967,8c10.144-.838,20.263-.675,30.419-.675,9.187-.046,18.386.044,27.576-.057",
    transform: "translate(21.347 175.861)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28107",
    "data-name": "Path 28107",
    d: "M2.623,3.132c12.051.843,24.1,1.707,36.152,2.52,7.453.5,14.953.708,22.374,1.524.631.069,1.07.1,1.35-.481-1.181-1.168-3.184-1.251-4.765-1.367C39.512,3.992,21.508,0,3.229,0H.047C-.247,1.709.869,2.454,2.623,3.132",
    transform: "translate(20.256 173.71)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28108",
    "data-name": "Path 28108",
    d: "M0,0C.064.045.121.1.185.14A.872.872,0,0,1,.312,0Z",
    transform: "translate(99.888 3.829)",
    fill: "#b2cac4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28109",
    "data-name": "Path 28109",
    d: "M100,55.64q-.076-7.045-.566-14.078c-.388-5.639-.821-11.443-1.566-17.2a106.058,106.058,0,0,0-3.3-16.356C93.483,4.338,91.491.971,87.373.43,78.323-.753,68.98.812,59.937,1.455c-9,.636-17.96,1.114-26.972,1.419-9.884.331-19.767.815-29.607,1.858C2.1,4.866-1.708,6.1.883,7.526A10.971,10.971,0,0,0,6.445,8.5c2.113-.013,4.258-.185,6.148,1.082,4.353,1.381,8.891,1.324,13.378,1.706,2.094-.585,4.455.414,6.39-1.082q5.069-.01,10.132-.025a1.223,1.223,0,0,0,.115.2c1.2.891,2.609.732,3.971.745,6.969.045,13.944.165,20.907-.108,2.5-.1,3.341.783,3.634,3.106.267,2.087.146,4.232.776,6.262a1.135,1.135,0,0,0,.656.681,2.409,2.409,0,0,0-.458.528c-.821,1.47-.751,3.456-.745,5.085.089,13.569.286,27.137.477,40.712.28,19.634.9,39.261,1.292,58.895.2,9.922.331,19.837.331,29.759.006,6.415,1.368,13.021.318,19.43-.535,3.246-1.947,7.192-5.912,6.969-1.082-.064-5.486-.827-5.461,1.209.006.948.961,1.279,1.795,1.47a16.036,16.036,0,0,0,6.536.076c5.753-.248,11.736.98,16.973-2.628.967-.9,2.514-1.133,3.023-2.584a4.741,4.741,0,0,0,.089-.948,511.077,511.077,0,0,0-2.247-52.091,17.557,17.557,0,0,0-.662-3.729c-4.614-14.1-4.226-30.956-3.373-45.6.178-3.048,1.037-5.492,4.582-5.683a5.618,5.618,0,0,1,4.474,1.909c2.877,3.335,2.9-.586,3.551-2.807.407-1.381,1.75-2.285,2.336-3.6,1.445-3.259.573-8.331.528-11.793",
    transform: "translate(66.197 0)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28110",
    "data-name": "Path 28110",
    d: "M7.949,1.037c1.082-.045,2.189.28,3.271.274.089.025.178.045.274.064-1.184-.083-2.368-.2-3.545-.337M0,0C1.031.1,2.062.223,3.087.4,2.056.261,1.031.127,0,0",
    transform: "translate(29.092 127.887)",
    fill: "#e3fbfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28111",
    "data-name": "Path 28111",
    d: "M1.5.185,1.356.146A9.7,9.7,0,0,0,0,0,4.877,4.877,0,0,0,.751.134c.248.019.5.038.751.051",
    transform: "translate(68.206 51.535)",
    fill: "#e3fbfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28112",
    "data-name": "Path 28112",
    d: "M.216.6A2.057,2.057,0,0,1,.172,0L0,.134A1.5,1.5,0,0,0,.216.6",
    transform: "translate(43.723 76.419)",
    fill: "#e7fafd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28113",
    "data-name": "Path 28113",
    d: "M1.489.221C1.146-.1.528.03,0,0A8.342,8.342,0,0,0,.916.2c.191.013.382.019.573.025",
    transform: "translate(44.805 77.605)",
    fill: "#e7fafd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28114",
    "data-name": "Path 28114",
    d: "M4.442.3C2.991.108,1.477.108,0,0A1.1,1.1,0,0,1,.134.045,22.719,22.719,0,0,0,4.442.3",
    transform: "translate(50.253 78.227)",
    fill: "#e7fafd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28115",
    "data-name": "Path 28115",
    d: "M1.5.185,1.356.146A9.7,9.7,0,0,0,0,0,4.877,4.877,0,0,0,.751.134c.248.019.5.038.751.051",
    transform: "translate(68.206 51.535)",
    fill: "#e7fafd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28116",
    "data-name": "Path 28116",
    d: "M2.173,117.531c3.706,0,7.416-.092,11.116.041,1.906.069,2.74-.694,2.859-2.483l-.006-.626a3.35,3.35,0,0,0,.725-2.663c-.582-10.873.182-21.77-.337-32.63-.7-14.669-.485-29.343-.853-44.011-.987-5.8-.308-11.638-.4-17.458.09-4.6.036-9.2.022-13.805,0-1.348.09-2.744-.862-3.894-2.178.146-1.564,1.9-1.608,3.067-.156,4.182,0,8.37-.1,12.553-.275,17.444,1.1,34.873.6,52.323a21.883,21.883,0,0,1-.19,3.8c-.293,1.44-1.372,1.8-2.6,1.8-1.3,0-1.459-1.057-1.526-2.016-.2-2.851-.052-5.71-.094-8.565a16.064,16.064,0,0,0-.283-3.788c-.379-1.479-.972-3.113-2.645-3.182s-1.279,1.844-1.832,2.867A19.8,19.8,0,0,0,3.828,63.4a12.578,12.578,0,0,1-.421,4.977c-1.363,9-1.6,18.078-2.182,27.135-.286,4.423-.52,8.852-.98,13.261a35.844,35.844,0,0,0-.19,6.008,2.6,2.6,0,0,0,2.118,2.746",
    transform: "translate(121.802 64.963)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28117",
    "data-name": "Path 28117",
    d: "M9.173,99.128l.6-.544c.518-4.44-.116-8.875-.372-13.276-.6-10.246-1.42-20.48-1.81-30.74a12.01,12.01,0,0,0-.216-1.895c-1.042-3.819-.658-7.79-.833-11.644C6.124,31.751,5.42,22.487,5.026,13.206,4.845,8.938,5.085,4.558,3.664.393.381-.4.02-.186.006,2.853c-.04,8.841.09,17.677.839,26.492a17.115,17.115,0,0,1,.479,5.707A58.525,58.525,0,0,0,2.879,50.059a3.528,3.528,0,0,1,.436,1.153C3.264,59.357,4.362,67.441,4.6,75.565c.2,6.962,1.424,13.882.846,20.873.16,1.749.887,2.955,2.851,2.978a1.4,1.4,0,0,0,.876-.288",
    transform: "translate(150.434 72.033)",
    fill: "#b9d2d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28118",
    "data-name": "Path 28118",
    d: "M40.365,111.287q.052,4.1.108,8.209.313,22.927.868,45.849a6.568,6.568,0,0,1-.435,3.127,2.252,2.252,0,0,1-2.612,1.284c-.608-39.245-1.106-78.495-1.915-117.734q-.048-2.334-.1-4.668c-.3-13.918-.443-27.839-.559-41.759a2.319,2.319,0,0,0-.368-1.524c-1.405-1.654-5.545-.478-7.3-.353A104.357,104.357,0,0,1,3.185,2.543C1.848,2.315.183,1.838,0,.33A2.018,2.018,0,0,1,1.361,0Q19.19.339,37.02.674a1.838,1.838,0,0,1,1.258.339,1.842,1.842,0,0,1,.395,1.333c.956,36.309,1.23,72.628,1.694,108.942",
    transform: "translate(99.437 9.614)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28119",
    "data-name": "Path 28119",
    d: "M.333,0C-.24.4.11,1.082.066,1.642.155,1.095.237.547.333,0",
    transform: "translate(136.417 98.02)",
    fill: "#d68d2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28120",
    "data-name": "Path 28120",
    d: "M4.169,51.168l-.85-15.286c-.465-1.644.284-3.395-.444-5.016-.446-8.721-.822-17.446-1.382-26.16-.169-2.64.782-3.488,3.246-2.972,1.79,1.09,3.616-.056,5.422.087.132-.082.263-.166.394-.251C8.148-1.12,5.05.426,2.38.591.109.732,1.069,3.29.98,4.832.848,7.143.945,9.468.945,11.786A6.774,6.774,0,0,0,.031,16.05c.783,9.893,1.627,19.781,1.884,29.707a3.774,3.774,0,0,0,.953,2.927c1.659,2.107-.37,4.864,1.231,6.98q.034-2.248.069-4.5",
    transform: "translate(149.144 70.924)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28121",
    "data-name": "Path 28121",
    d: "M3.192.415l-.3-.081L2.578.363C1.611.143.515-.6,0,1Q.026,4.851.05,8.7A8.569,8.569,0,0,0,3.192.415",
    transform: "translate(156.415 170.746)",
    fill: "#871f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28122",
    "data-name": "Path 28122",
    d: "M.619,3.276c.695-.877,1.7-.5,2.579-.64C1.9,2.07.255,1.9.084,0,.146,1.111-.381,2.318.619,3.276",
    transform: "translate(155.796 168.472)",
    fill: "#871f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28123",
    "data-name": "Path 28123",
    d: "M0,14.935c.624.108,1.26.153,1.884.2A7.6,7.6,0,0,1,0,14.935M1.6,0C2.686-.04,3.793.284,4.875.278c.089.025.178.045.274.064C3.965.259,2.781.138,1.6,0M7.459,15.73a17.834,17.834,0,0,1,2.921.312c-.974-.1-1.947-.2-2.921-.312",
    transform: "translate(35.437 128.92)",
    fill: "#edfcfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28124",
    "data-name": "Path 28124",
    d: "M3.8,59.847C3.025,67.577,2.224,75.3,1.475,83.036.948,88.473.489,93.915,0,99.355l8.2-.176c-2.437-2.282-1.419-5.29-1.014-7.74.656-3.974.442-7.964.9-11.934C9,71.688,9.055,63.776,9.574,55.91c.138-2.087.756-4.139.6-6.264.78-1.409-.219-3.061.608-4.463q.018-2.222.036-4.445c2.816-11.182,1.991-22.731,3.424-34.053a9.979,9.979,0,0,0-.209-3.756C12.358,2.494,11.527.937,10.215,0,8.681,1.986,8.9,4.481,8.7,6.685c-.408,4.42-1,8.823-1.345,13.25C6.28,31.194,4.957,42.423,3.678,53.656c-.242,2.119.428,4.127.126,6.192",
    transform: "translate(115.773 83.315)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28125",
    "data-name": "Path 28125",
    d: "M1.865,21.6c-.1,1.21-.265,2.415-.367,3.624a49.223,49.223,0,0,0,.2,8.4c.127,1.464.287,2.926.464,4.384a21.218,21.218,0,0,1,.549,4.23c-.433,4.2,3.168,7.115,3.507,11.188.186,2.237,6.1,3.774,7.945,2.369,1.055-.8.839-2.073.937-3.213.42-4.859-.867-9.643-.62-14.491.055-1.1-.386-2.385.948-3.089,1.984.055,1.636,1.636,1.676,2.753.123,3.439.865,6.828.754,10.287A6.733,6.733,0,0,0,18.965,51.9a2.4,2.4,0,0,0,2.982,1.127c1.322-.528.808-1.789.838-2.768a5.231,5.231,0,0,0-.245-2.784c.5-5.57-.463-11.076-.81-16.6A6.987,6.987,0,0,0,18.1,25.285a12.64,12.64,0,0,0-9.422-1.023c-1.954.577-3.131-.463-3.071-2.766C5.774,14.973,4.464,8.534,4.363,2.022,4.347.985,4.21.1,2.92.007a1.9,1.9,0,0,0-2.1,1.529,12.859,12.859,0,0,0-.671,6.08A1.66,1.66,0,0,0,1.184,8.949",
    transform: "translate(159.412 85.394)",
    fill: "#871f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28126",
    "data-name": "Path 28126",
    d: "M20.266,13.845c-.014.817.017,1.638-.055,2.45-.076.865.382,1.927-.632,2.506-1.235.7-1.79-.517-2.586-1.036-1.714,3.528-.895,7.246-.614,10.86.221,2.844.3,5.688.446,8.532.034.671.321,1.718-.656,1.856-1.212.171-1.235-1.013-1.25-1.778-.085-4.538-.234-9.067-.73-13.584C13.328,15.79,13.781,7.847,12.7,0c-1.866.137-1.394,1.586-1.363,2.632.162,5.364.483,10.726.538,16.09.01.933,1.292,3.08-1.319,2.88-2.421-.186-5.62.934-6.208-3.011-.17-1.139.164-2.378-.134-3.462-.176-.642.411-3.175-1.957-1.408-.7.521-.386-.6-.454-.94-.262-1.3.473-2.76-.642-3.928C-.573,11.234.08,13.95.327,16.5c.875,9.021,1.079,18.08,1.751,27.11.11,1.475-.419,3.246,1.5,4.083,1.326-.066,2.7.209,3.744-1.07.478-.587,1.144-.533,1.949-.1,4.023,2.161,5.938,1.573,8.777-1.89,1.232-1.5,2.679-2.812,3.5-4.618a162.855,162.855,0,0,0-1.284-26.165",
    transform: "translate(161.687 119.026)",
    fill: "#871f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28127",
    "data-name": "Path 28127",
    d: "M1.954,21a16.369,16.369,0,0,0,.42-1.814c.106-.878.476-1.384,1.421-1.276a1.169,1.169,0,0,1,1.087,1.3c.1,3.891.088,7.771.521,11.668.362,3.256,1.042,6.488.967,9.824a2.125,2.125,0,0,0,3.292,1.775c2.827-1.581,5.364-1.238,8.039.106.337.169.834.019,1.256.017-2.274-2.352-5.232-1.906-7.985-1.7-3.152.237-4.779-.58-4.206-4.047a20.8,20.8,0,0,0,.056-3.134C6.209,23.748,5.622,13.772,4.955,3.8A5.756,5.756,0,0,1,6.155,0C2.389.948,4.34,4.55,3.242,6.807c-1.173-.592-.975-2.057-2.1-2.389l-.193.144A24.774,24.774,0,0,0,1.954,21",
    transform: "translate(158.554 68.077)",
    fill: "#871f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28128",
    "data-name": "Path 28128",
    d: "M11.23,94.7c0-.146-.011-.3-.022-.445q-.411-6.264-.834-12.528c-.75-11.262-1.509-22.51-2.029-33.78-.36-7.8-.739-15.784-1.271-23.645C6.541,16.422,5.471,8.529,5.626.619,3.742-.775,1.877.619,0,.638c.116,0,1.6,33.016,1.742,35.845.4,7.874,1.348,15.693,1.653,23.559.241,6.224.785,12.377,1.228,18.572.265,3.689.337,7.387.547,11.078.11,1.942.255,3.882.486,5.813.077.639,0,2.144.358,2.665.435.632.77.258,1.564.381,2.97.463,3.722-1.405,3.651-3.852",
    transform: "translate(153.882 72.02)",
    fill: "#e7fcfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28129",
    "data-name": "Path 28129",
    d: "M26.778,3.161Q16,1.861,5.224.552C4.3.438,3.391.21,2.475.035,1.663.448.029-.774,0,.981c-.023,1.37,1.435.878,2.261.991,4.568.623,9.145,1.174,13.72,1.75l10.8.724a1.038,1.038,0,0,0,.36-.645,1.027,1.027,0,0,0-.364-.641",
    transform: "translate(31.72 142.536)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28130",
    "data-name": "Path 28130",
    d: "M14.4,3.665l5.515.2a1.375,1.375,0,0,0,.9.082c1.022-.379,2.235.108,3.165-.7q.315-.526-.279-.677C16.064,2.112,8.481,1.144.918,0L.76.085.6,0c-.986,1.084-.761,1.832.659,2.138.8.171,1.668-.153,2.438.309A62.871,62.871,0,0,1,14.4,3.665",
    transform: "translate(20.587 126.019)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28131",
    "data-name": "Path 28131",
    d: "M16.3,2.466c-.65-.771-1.87-.568-2.786-.724Q11.5,1.4,9.467,1.17C8.27,1.035,2.6-.481.056.155-.6.32,4.736,1.9,6.42,2.065c2.25.214,2.6.384,4.853.6a19.97,19.97,0,0,0,3.066.219c.19-.012,1.939-.438,1.958-.415",
    transform: "translate(77.525 179.282)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28132",
    "data-name": "Path 28132",
    d: "M4.057,2.448a11.915,11.915,0,0,0-2.108-.433C.243,1.968.353,1.13.959,0c-1.35,1.2-1.383,2.127.6,2.456a14.385,14.385,0,0,0,2.5-.008",
    transform: "translate(20.23 126.019)",
    fill: "#f0fcfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28133",
    "data-name": "Path 28133",
    d: "M2.259.248A6.128,6.128,0,0,0,1.578.115,9.8,9.8,0,0,0,.146,0H0C.172.032.337.076.5.121c.586.025,1.171.07,1.757.127",
    transform: "translate(28.385 103.531)",
    fill: "#ebfbfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28134",
    "data-name": "Path 28134",
    d: "M2.355.318A7.141,7.141,0,0,0,0,0C.261.051.522.1.783.146L2.355.318",
    transform: "translate(33.298 104.136)",
    fill: "#ebfbfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28135",
    "data-name": "Path 28135",
    d: "M.216.6A2.057,2.057,0,0,1,.172,0L0,.134A1.5,1.5,0,0,0,.216.6",
    transform: "translate(43.723 76.419)",
    fill: "#ebfbfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28136",
    "data-name": "Path 28136",
    d: "M1.489.221C1.146-.1.528.03,0,0A8.342,8.342,0,0,0,.916.2c.191.013.382.019.573.025",
    transform: "translate(44.805 77.605)",
    fill: "#ebfbfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28137",
    "data-name": "Path 28137",
    d: "M4.442.3C2.991.108,1.477.108,0,0A1.1,1.1,0,0,1,.134.045,22.719,22.719,0,0,0,4.442.3",
    transform: "translate(50.253 78.227)",
    fill: "#ebfbfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28138",
    "data-name": "Path 28138",
    d: "M4.442.484Q2.227.216,0,0C.21.045.42.083.63.134,1.9.2,3.163.458,4.442.484",
    transform: "translate(53.81 84.438)",
    fill: "#ebfbfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28139",
    "data-name": "Path 28139",
    d: "M19.237.819c2.09.709,1.553,2.3,1.181,3.743-1.077,4.183-1.855,8.378-.664,12.663.246.887.81,1.68,1.145,2.548.581,1.5-.829.5-1.148.877a.77.77,0,0,0,.292.887A3.371,3.371,0,0,0,21.465,22a25.464,25.464,0,0,1,5.284.459c1.021.189,2.066.2,3.32.347-2.948.3-5.784-1.611-8.421.413,2.172,2.012,9.97,2.765,12.1,1.17,1.966-1.469,2.107-5.084.3-7.113-.626-.7-1.653-.953-2.081-1.872,2.424-1.328,3.55-1.069,4.244,1.105,1.075,3.369.4,6.915.925,10.362.255,1.68-2.185.878-2.758,2.08.736,1.885,2.533,1.242,3.824,1.406,5.533.7,11.09,1.229,16.624,1.952-10.463-1.261-20.948-2.334-31.4-3.67a10.616,10.616,0,0,1-3.613-.4,12.95,12.95,0,0,0-2.157-.268c-2.118.12-4.169-.435-6.255-.605-1.241-.1-2.541-.19-3.588.761.356.658.979.7,1.627.737.91.053,2.112-.168,2.055,1.276-.064,1.649-1.456,1.317-2.395,1.223-3.027-.3-6.031-.89-9.1-.523.516,1.641,1.97,1.33,3.166,1.48,4.92.619,9.884.846,14.784,1.645,9.208.869,18.381,2.076,27.584,2.992a11.513,11.513,0,0,0,2.063.2c1.249.27,2.558.05,3.793.442a4.683,4.683,0,0,0,.886.137,21.242,21.242,0,0,1,3.17.174c-.951.1-1.839-.241-2.754-.139-4.02-.243-7.981-.975-11.985-1.31a6.153,6.153,0,0,0-3.118.148c-1.385,1.541.121,1.7,1.011,1.82,1.872.257,3.736.577,5.615.8.609.071,1.433,0,1.638.682.279.932-.885,1-1.245,1.59a.9.9,0,0,0,.073.906,2.652,2.652,0,0,0,1.287.573c2.727.1,5.429.483,8.276.834-2.6.052-5.078-1.23-7.53.074-.388,1.712,1.014,1.4,1.893,1.649.943.264,2.137-.148,2.774,1.036-.753.935-2.089.4-2.849,1.206.482,2.907,3.077.584,4.06,1.989-.272.237-1.139.032-1.547.681C52.32,53.1,54.323,54,57.317,53.779c2.625-.192,5.012,1.948,7.836,1.417.108-.02.35.673.53,1.034,1.366-2.075.673-4.5.948-6.719C68,38.412,69,27.267,70.125,16.138c-1.522-1.128-2.786.073-4.121.481-3.031.927-4.059.294-4.426-2.857-.194-1.671-.083-3.355-.125-5.033-.041-1.652-.421-3.123-1.947-4.058-4.294-1.659-8.9-1.363-13.344-2.038-4.879-.74-9.815-1.141-14.74-1.539A5.436,5.436,0,0,0,30.386.81C28.288.477,26.114.936,24.052.2,22.4.069,20.709-.4,19.237.819",
    transform: "translate(53.894 86.932)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28140",
    "data-name": "Path 28140",
    d: "M52.014,15.472a16.053,16.053,0,0,1,1.9-.051c2.174.188,2.709-.283,1.834-2.62-1.217-3.253.106-6.9-1-10.3C54.407,1.46,54.4.276,53.056.237,51.418.188,49.5-.536,48.213.817c-1.114,1.167-.249,2.147,1.112,2.5,2.861.754,3.082,2.949,2.748,5.252-.377,2.6-2.5,2.534-4.425,2.361-2.758-.249-5.592-.125-8.193-1.356a.675.675,0,0,0-.34-.9c-1.905-.574-3.948-.319-5.842-.977C23.542,7,13.892,5.558,4.195,4.553c-1.469-.152-2.924-.5-4.195.6A6.827,6.827,0,0,0,5.057,8.823C3.492,10.234,1.872,9.4.493,9.741c.462,1.777,2.075,1.224,3.157,1.367,5.2.685,10.417,1.284,15.643,1.762,1.411.245,2.866.164,4.261.55a17.35,17.35,0,0,1,2.161.238c6.95.5,13.837,1.655,20.8,2a18.685,18.685,0,0,1,4.072.183,1.782,1.782,0,0,0,1.429-.365",
    transform: "translate(36.256 100.381)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28141",
    "data-name": "Path 28141",
    d: "M57.94,9.811c.831-.027,1.662-.046,2.492-.081.92-.039,2,.124,2.035-1.279.025-1.215-.974-1.488-1.848-1.786-1.429-.489-3.148.561-4.425-.81-1.731-2.3-4.527-.864-6.623-1.892C37.995,2.81,26.472,1.169,14.875.2c-1.527-.053-3.127-.673-4.486.577a24.927,24.927,0,0,0,8.235,1.347c.64.012,1.708-.309,1.6.876a1.415,1.415,0,0,1-1.551,1.265c-2.116-.021-4.245.7-6.213-1.021-1.23-1.074-3.153-.776-4.6-.4C5.237,3.522,2.61,3.193,0,3.45A2.891,2.891,0,0,0,.423,3.9c.514.866,1.437.656,2.209.843,1.249.195,2.543-.039,3.766.4a6.333,6.333,0,0,0,.934.13c1.69.333,3.436,0,5.12.421a4.834,4.834,0,0,0,.923.2c1.552.316,3.173.062,4.7.573.491.071.986.083,1.481.111,1.512.263,3.066.167,4.56.575,6.091.61,12.152,1.482,18.249,2,1.166.277,2.4.079,3.547.475a19.878,19.878,0,0,0,2,.134c1.459.307,2.986.021,4.426.515.34.053.68.091,1.023.119,1.577.213,3.167.535,4.572-.582",
    transform: "translate(44.293 125.141)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28142",
    "data-name": "Path 28142",
    d: "M50.1,5.708c-4.909-.6-9.819-1.186-14.725-1.8-1.14-.143-2.267-.389-3.4-.588Q17.95,1.838,3.928.357A10.5,10.5,0,0,0,2.356.177C1.507.219.1-.551,0,.83c-.094,1.286,1.4.946,2.247,1.051C10.944,2.956,19.642,3.987,28.34,5.03A69.735,69.735,0,0,0,39.817,6.246c.775-.95,1.95-.769,2.729-.773-.46.406-1.6-.424-2.237.457,1.16,1.426,2.8,1.024,4.3,1.126,1.505-.57,3.146-.242,4.672-.687a1.7,1.7,0,0,0,.813-.661",
    transform: "translate(21.921 114.457)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28143",
    "data-name": "Path 28143",
    d: "M6.5,1.591C18.092,3.117,29.686,4.606,41.348,5.482c1.985.013,4.1,1.131,5.872-.68l-1.06-.1c-1.221-.931-2.8-.68-4.127-1.242C35.579,2.011,28.952,1.864,22.439.85,18.764.31,15.04,1,11.366.405L6.071.265C4.517-.224,2.92.136,1.347.025A5.085,5.085,0,0,0,.3.109a.789.789,0,0,0-.244.927,2.852,2.852,0,0,0,1.5.241C3.2,1.456,4.891.906,6.5,1.591",
    transform: "translate(52.621 124.365)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28144",
    "data-name": "Path 28144",
    d: "M5.913,1.946q14.1,1.486,28.2,2.963c1.771.183,3.555.246,5.333.365,1.779-.048,3.746,1.289,5.258-.717l-.978-.091a9.453,9.453,0,0,0-3.555-.524c-1.37-.281-2.752.749-3.918.191.336.34.93.1,1.522-.1q.325-.561-.317-.647Q23.618,1.924,9.783.476C7.689.26,5.585.156,3.485,0L3.024.072C2.006.3.785-.255,0,.862L5.913,1.946",
    transform: "translate(30.342 103.585)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28145",
    "data-name": "Path 28145",
    d: "M39.085,4.449l-1.616-.118c-1.315-.559-2.79.159-4.091-.515L14.168,1.285C10.064.878,5.959.462,1.854.07,1.14,0,.207-.223.02.776c-.16.85.664.925,1.28.983,10.647.988,21.209,2.781,31.9,3.355,1.989.018,4.1,1.1,5.886-.664",
    transform: "translate(22.581 108.836)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28146",
    "data-name": "Path 28146",
    d: "M31.17,4.419l.662-.017c.207-.142.276-.283.208-.426s-.136-.214-.2-.214l-.216-.123-.243.051c-1.282-.57-2.721.141-4-.487l-1.736-.147c-1.067-.519-2.284.066-3.351-.452C15.563,1.8,8.836.987,2.106.209,1.353.123.191-.461.017.8c-.179,1.3,1.115,1,1.842,1.081,6.31.691,12.626,1.33,18.941,1.984,1.73.979,3.652.285,5.457.625a9.149,9.149,0,0,0,.992.233c1.342.341,2.681.634,3.922-.308",
    transform: "translate(21.58 120.293)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28147",
    "data-name": "Path 28147",
    d: "M13.727,5.284A59.9,59.9,0,0,0,24.789,6.532a.81.81,0,0,0-.635-1.167C21.575,4.7,22.349,3.5,23.6,2.191c-1.663-1.587-3.806-.32-5.63-.956a1.539,1.539,0,0,0-1.437.12A9.888,9.888,0,0,1,11.963.839l-.015,0L0,0C.617,1.06,1.668.643,2.569.767c5.482.754,10.959,1.539,16.612,3.58-1.958,1.47-3.822.516-5.454.937",
    transform: "translate(50.261 119.487)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28148",
    "data-name": "Path 28148",
    d: "M5.886,0C4.039,1.241,1.941.255,0,.664,1.845,1.723,4.064.789,5.923,1.776l10.168.7c1.859-.7,3.631.215,5.449.295,1.928-.124,3.852.877,5.782.02q.537-.419.017-.856L5.886,0",
    transform: "translate(55.78 113.285)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28149",
    "data-name": "Path 28149",
    d: "M11.582,1.266C9.955.554,8.217.766,6.517.651,5.025.063,3.375.885,1.9.137.863-.075-.159-.263.021,1.375l1.1.094c1.693.642,3.549-.251,5.225.554l1.24.039c1.118-.852,2.5.015,3.66-.564q.169-.111.332-.232",
    transform: "translate(22.245 102.32)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28150",
    "data-name": "Path 28150",
    d: "M0,.841l0,.675,5.072.13,1.976-.169c-.3-1.6-1.641-1.261-2.7-1.452C2.861.079,1.284-.323,0,.841",
    transform: "translate(27.334 88.19)",
    fill: "#dde8ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28151",
    "data-name": "Path 28151",
    d: "M0,.306C1.816,1.691,3.886.749,5.832.944q.212-.386-.214-.5l.055.01A10.745,10.745,0,0,0,0,.306",
    transform: "translate(42.616 124.328)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28152",
    "data-name": "Path 28152",
    d: "M.237.638,5.909.791C4.06-.56,1.984.247,0,.166Q.117.4.237.638",
    transform: "translate(42.38 123.996)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28153",
    "data-name": "Path 28153",
    d: "M0,0c0,.213,0,.427,0,.64L5.281.58C3.579-.136,1.782.02,0,0",
    transform: "translate(53.411 124.05)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28154",
    "data-name": "Path 28154",
    d: "M5.214.691C3.588-.53,1.747.266,0,.137A.4.4,0,0,0,.39.622.228.228,0,0,1,.772.653L5.214.691",
    transform: "translate(53.91 125.265)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28155",
    "data-name": "Path 28155",
    d: "M5.224.69C3.584-.443,1.758.168,0,.137A10.88,10.88,0,0,0,5.224.69",
    transform: "translate(23.371 103.651)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28156",
    "data-name": "Path 28156",
    d: "M5.345.914Q5.163.662,4.959.429L3.82.353A5.339,5.339,0,0,0,0,.354c1.668,1.272,3.556.438,5.345.56",
    transform: "translate(48.955 124.973)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28157",
    "data-name": "Path 28157",
    d: "M.722.615h3.82q0-.307-.026-.614L0,.065a1.835,1.835,0,0,0,.214.5A.426.426,0,0,1,.722.615",
    transform: "translate(48.233 124.713)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28158",
    "data-name": "Path 28158",
    d: "M3.659.13C2.418.179,1.072-.453,0,.694A.388.388,0,0,0,.506.76c1.013-.4,2.256.347,3.153-.63",
    transform: "translate(29.836 103.687)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28159",
    "data-name": "Path 28159",
    d: "M0,.048C1.228,1.07,2.644.539,4,.535A7.876,7.876,0,0,0,0,.048",
    transform: "translate(48.958 123.447)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28160",
    "data-name": "Path 28160",
    d: "M0,.044C1.016.946,2.209.529,3.351.5A6.481,6.481,0,0,0,0,.044",
    transform: "translate(43.87 122.853)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28161",
    "data-name": "Path 28161",
    d: "M.1,0C.083,2.126.045,4.213,0,6.243c.331-.821-.006-2.189.121-3.519C.2,1.833.1.9.1,0",
    transform: "translate(138.239 111.862)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28162",
    "data-name": "Path 28162",
    d: "M58.592,50.184c.323.237.665.7.967.678,3.684-.291,2.38,1.626,1.522,3.358,0,.961-.647,1.04-1.4,1.12s-1.671,0-1.885,1.079c3.264,1.095,4.832,2.789,3.54,6.627-.731,2.173,1.3,4.214,3.77,3.866,2.827-.4,3.934.677,4.411,3.144a.915.915,0,0,0,.932.7,2.975,2.975,0,0,0,1.1-2.518c1.379-13.345,2.648-26.7,4.38-40.008a21.686,21.686,0,0,0,.052-2.856,10.282,10.282,0,0,1,.386-3.768,8.516,8.516,0,0,0,.221-1.673c-.159-2.731.78-5.356.694-8.1C77.146,7.5,76.87,7.054,72.64,6.336a29.1,29.1,0,0,0-3.752-.2c-4.865-.792-9.829.148-14.68-.85C48,5.169,41.923,3.774,35.686,3.565c-4.146-.139-8.264-1.2-12.461-.3a1.48,1.48,0,0,1-1.231-.192C19.418.707,16.019,1.385,13.024.588c-.937-.077-1.8-1.142-2.814-.2C8.337.822,6.84,2.6,4.436.945,2.885-.123.158,2.153.061,4.254-.046,6.58.013,8.915.046,11.246a4.4,4.4,0,0,0,2.246,3.987c2.585,1.28,4.185,3.473,5.988,5.5,1.708,1.92,3.626,3.178,6.352,2.882,2.52-.273,3.7,1.456,4.243,3.483a6.676,6.676,0,0,0,4.447,4.952c2.7.955,3.819,3.614,5.565,5.491,3.015,3.244,6.706,3.665,10.593,3.844,5.994.276,12.055-.63,17.959,1.232a13.276,13.276,0,0,1,2.585,1.04c1.263.707,1.992,1.605,1.629,3.068-.375,1.507-1.68.912-2.644,1.034-.628.08-1.268.071-1.9.1.752,2.041,2.724.9,4.032,1.548-.859.264-1.856.027-2.547.776",
    transform: "translate(56.559 7.588)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28163",
    "data-name": "Path 28163",
    d: "M10.311,2.2c9.9,1.3,19.813,2.542,29.775,3.3,1.383.482,2.813.129,4.216.237.65-.062,1.434.221,1.766-.673a.692.692,0,0,0-.719-.563,24.3,24.3,0,0,1-3.88-.57c-1.082-.265-2.247.2-3.3-.365l-.262.076-.244-.12c-1.666-.819-3.539.181-5.21-.594L32.191,3l-.249-.118c-1.484-.765-3.169.121-4.662-.566L26.21,2.224c-1.485-.714-3.154.133-4.643-.545l-1.085-.106c-1.455-.706-3.1.182-4.556-.554l-.273.07L15.4.967C14,.351,12.536.816,11.111.671,9.364.5,7.574,1.033,5.859.344L5.61.237,5.345.29C3.7-.218,2.019.1.353.1a.6.6,0,0,0-.221.925.288.288,0,0,0,.416.047c1.512.6,3.188-.239,4.681.533L6.3,1.7c1.286.577,2.739-.163,4.013.507",
    transform: "translate(62.816 50.561)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28164",
    "data-name": "Path 28164",
    d: "M18.4,3.617c0-.225,0-.451,0-.677q.335-.218.22-.428t-.228-.21l-.229-.114-.25.052a23.541,23.541,0,0,0-4.375-.726c-.775-.265-1.636-.045-2.394-.414l-1.013-.069C8.636.257,6.94,1.139,5.434.46L3.75.323C2.471.112,1.163-.43,0,.656.229,1.875,1.21,2,2.164,2.089c3.465.314,6.934.6,10.4.891,1.671.752,3.544-.265,5.2.6l.631.039",
    transform: "translate(44.552 47.967)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28165",
    "data-name": "Path 28165",
    d: "M10.407,2.636l2.546.321c3.134.789,6.279,1.421,9.522.671-1.017-1.382-2.506-1.32-3.987-1.324A27.665,27.665,0,0,1,11,1.723C10,1.446,10.218.993,10.379.38,6.873-.027,3.364-.462,0,1.121L10.407,2.636",
    transform: "translate(56.362 5.337)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28166",
    "data-name": "Path 28166",
    d: "M1.508.356a1.427,1.427,0,0,1-1.3.689q-.284.205-.176.389c.07.119.139.179.207.179L7.9,2.778c1.523-.467,4.4.978,4.4-.5C12.3.021,9.424,1.494,7.91.9,7.43.708,6.918.6,6.42.454L5.325.361A5.259,5.259,0,0,0,1.508.356",
    transform: "translate(107.246 54.995)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28167",
    "data-name": "Path 28167",
    d: "M2.966,2.063c3.411-.93,6.9-.745,10.38-.741l.021,0c1.622-.806,3.444.165,5.074-.57,2.543-.395,5.2.54,7.674-.676C17.639-.256,9.222.575.808,1.422.526,1.451.269,1.729,0,1.89l2.966.173",
    transform: "translate(53.395 4.395)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28168",
    "data-name": "Path 28168",
    d: "M0,.108,3.313.8A2.932,2.932,0,0,0,5.856.694C4.009-.55,1.953.3,0,.108",
    transform: "translate(100.989 54.022)",
    fill: "#ddfafd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28169",
    "data-name": "Path 28169",
    d: "M0,.009.008.648,5.217.592C3.54-.161,1.759.026,0,.009",
    transform: "translate(62.944 50.26)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28170",
    "data-name": "Path 28170",
    d: "M0,.111C1.677.835,3.453.688,5.21.705,3.595-.557,1.737.3,0,.111",
    transform: "translate(95.274 53.381)",
    fill: "#ddfafd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28171",
    "data-name": "Path 28171",
    d: "M0,0C1.626,1.207,3.464.482,5.212.572a.352.352,0,0,0-.319-.5L0,0",
    transform: "translate(68.675 50.905)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28172",
    "data-name": "Path 28172",
    d: "M.816.689,4.632.7C3.213-.514,1.561.241.009.15A.361.361,0,0,0,.328.612.471.471,0,0,1,.816.689",
    transform: "translate(107.939 54.661)",
    fill: "#ddfafd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28173",
    "data-name": "Path 28173",
    d: "M0,.125A10.692,10.692,0,0,0,4.662.691C3.232-.52,1.561.258,0,.125",
    transform: "translate(90.095 52.753)",
    fill: "#ddfafd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28174",
    "data-name": "Path 28174",
    d: "M0,.123A10.835,10.835,0,0,0,4.643.668C3.211-.5,1.554.248,0,.123",
    transform: "translate(84.382 52.117)",
    fill: "#ddfafd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28175",
    "data-name": "Path 28175",
    d: "M0,.1A9.961,9.961,0,0,0,4.555.652C3.153-.493,1.522.253,0,.1",
    transform: "translate(78.742 51.484)",
    fill: "#ddfafd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28176",
    "data-name": "Path 28176",
    d: "M0,.131c.113.163.219.33.319.5L4.646.684C3.217-.511,1.557.249,0,.131",
    transform: "translate(73.569 50.844)",
    fill: "#ddfafd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28177",
    "data-name": "Path 28177",
    d: "M0,.4C1.425,1.53,3.061.844,4.607.938A5.183,5.183,0,0,1,4.252.469L3.191.38A3.455,3.455,0,0,0,0,.4",
    transform: "translate(57.857 49.269)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28178",
    "data-name": "Path 28178",
    d: "M3.964.558Q3.793.334,3.646.095L2.544,0,0,.105c1.233.931,2.621.488,3.964.452",
    transform: "translate(104.302 54.716)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28179",
    "data-name": "Path 28179",
    d: "M50.885,19.184c-.1-4.207-.339-4.455-4.362-4.466-3.224-.01-4.258-1.311-3.407-4.287,1.3-4.526,1.294-4.519-3.568-5.359-.276-.048-.507-.349-.758-.533C36.942,2.313,34.2,3.514,31.966,2.755a6.547,6.547,0,0,0-1.045-.107,44.49,44.49,0,0,1-5.28-.6C19.955,1.572,14.309.743,8.634.191,7.421.073,6.086-.4,5.074.8,8.459,2.5,6.82,5.581,6.816,8.027c0,2.136-2.05,2.377-3.84,2.227C.921,10.082.09,11.141,0,13.027c-.1,2.1,1.26,2.4,2.914,2.332.42-.017.978-.137,1.243.076,3.649,2.933,8.221,2.205,12.342,3.252a30.294,30.294,0,0,0,6.263.477c1.2.057,2.544.052,2.52,1.66A2.078,2.078,0,0,1,22.783,23c-.838-.053-1.685.048-2.528.079a.8.8,0,0,0,.243.831c4.7,1.049,9.521,1.24,14.288,1.816a17.791,17.791,0,0,1,4.573.852c.036.015.032.2,0,.294a.83.83,0,0,1-.192.262A10.42,10.42,0,0,1,35.561,30.5c.144,2.233,2.286.951,3.209,1.823-.391.3-.932.358-1.25.775,1.579,1.216,1.29,2.949,1.269,4.6-.109,8.829.7,10.082,8.6,6.332a2.582,2.582,0,0,1,.938-.052c1.086-6.55.9-13.264,2.537-19.744a3.9,3.9,0,0,0,.017-5.054",
    transform: "translate(75.689 59.088)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28180",
    "data-name": "Path 28180",
    d: "M54.067,6.3a1.953,1.953,0,0,1-.136-.45l.066,0C50,4.449,45.8,4.97,41.7,4.555l-1.7-.122c-1.277-.62-2.729.113-4.005-.516l-1.727-.15c-1.273-.565-2.7.142-3.969-.493l-.238.083-.22-.123c-1.484-.808-3.184.111-4.682-.587L24.112,2.56c-1.5-.722-3.179.117-4.684-.547l-1.039-.08c-1.48-.752-3.158.13-4.645-.564L8.353,1.242C6.879.583,5.223,1.46,3.762.7,3.176.364,2.347.716,1.89.024A1.521,1.521,0,0,0,0,1.1l3.588.923c1.279.57,2.711-.131,3.986.479L22.206,4.467C26.232,6.179,30.59,5.954,34.8,6.6a16.087,16.087,0,0,1,2.8.289,6.149,6.149,0,0,0,1.072.26c3.9.063,7.731,1.037,11.649.8,1.349-.327,3.231.547,3.752-1.654",
    transform: "translate(42.014 76.314)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28181",
    "data-name": "Path 28181",
    d: "M20.46,3.6,41.379,5.556l.468-.075c1.184-.284,2.583.425,3.569-.771A13.155,13.155,0,0,0,40.2,4.134c-.818.717-1.863.088-2.739.465-.423.024-.1-.384-.009-.35a1.974,1.974,0,0,0,2.22-.172C30.389,2.722,21.074,1.618,11.715.9c-1.48-.661-3.16.27-4.617-.578L6.013.252A24.312,24.312,0,0,0,.422.076.553.553,0,0,0,.105.949l1.049.127c1.3.535,2.754-.178,4.039.492l1.685.145c1.09.476,2.323-.107,3.4.46l4.471.771c1.277.613,2.726-.116,4,.513L20.46,3.6",
    transform: "translate(60.303 56.291)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28182",
    "data-name": "Path 28182",
    d: "M30.832,2.609Q18.867,1.382,6.9.165C5.646.039,4.377.052,3.113,0,2.2.827.851-.482,0,.639,4.01,2.25,8.342,1.7,12.476,2.49c1.529.292,3.08.468,4.622.7,1.505.78,3.211-.094,4.731.575l1,.082c1.493.743,3.177-.118,4.678.558l1.048.086c2.859.449,3.036.3,2.276-1.878",
    transform: "translate(43.943 60.432)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28183",
    "data-name": "Path 28183",
    d: "M.094,8.715,0,12.995a5.309,5.309,0,0,0,4.044.44c.8-.454.614-1,.046-1.452A2.99,2.99,0,0,1,2.806,9.3a10.859,10.859,0,0,1,.363-2.233C3.655,3.3,3.654,3.32,7.5,3.587c1.883.13,3.8-.031,5.6.733A2.533,2.533,0,0,0,14.97,3.9c.551-.49.856-1.028.333-1.726l-.636-.125C13.115.664,11.078,1.644,9.381.963l-.222.087L8.951.933C7.241.075,5.328,1.051,3.6.335,1.9-.212.437-.382.712,2.176-.2,4.289.876,6.59.094,8.715",
    transform: "translate(26.018 45.547)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28184",
    "data-name": "Path 28184",
    d: "M0,.815a11.747,11.747,0,0,0,5.14.537C6.148.565,7.382,1.308,8.453.927c-.9.292-1.975-.3-2.779.486L12.8,2.594c.93.034,1.86.094,2.791.091.668,0,1.6.5,1.9-.449.426-1.32-1.059-.918-1.532-1.46L4.557,0C3.192.831,1.639.064.228.507A.766.766,0,0,0,0,.815",
    transform: "translate(101.682 61.032)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28185",
    "data-name": "Path 28185",
    d: "M0,.6A65.077,65.077,0,0,0,12.294,1.9C8.476-1.175,4.171.344,0,.6",
    transform: "translate(83.717 80.267)",
    fill: "#e3fafe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28186",
    "data-name": "Path 28186",
    d: "M5.829.6,4.147.439C3.053-.018,1.829.528.744,0-.246.512-.294.953.878,1.181c1.384.269,2.781.467,4.172.7,1.9.755,4-.346,5.879.625a.463.463,0,0,0,.521.052l.426-.062a21.227,21.227,0,0,0,3.02-.2,1.206,1.206,0,0,0,.609-.6,17.957,17.957,0,0,0-5.613-.607C8.582.556,7.127,1.239,5.829.6",
    transform: "translate(44.401 54.176)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28187",
    "data-name": "Path 28187",
    d: "M2.278,0,.992.613C-.021,1.422.078,2.585,0,3.693.149,5.1-.22,6.67,1.109,7.717c1.018-.48.552-1.421.939-2.018q.124-2.231.247-4.461A1,1,0,0,0,2.278,0",
    transform: "translate(38.515 49.03)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28188",
    "data-name": "Path 28188",
    d: "M2.746,2.052l-.988,1.61C1.663,2.243,1.588,1.121,1.514,0-.128.433.353,1.925.009,3.007A2.116,2.116,0,0,0,.586,4.659a2.141,2.141,0,0,0,2.023.581q.141-.643.282-1.287l-.145-1.9",
    transform: "translate(37.818 52.676)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28189",
    "data-name": "Path 28189",
    d: "M0,.185,5.286,1.274C3.923-1.026,1.757.57,0,.185",
    transform: "translate(35.399 46.325)",
    fill: "#e3fbfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28190",
    "data-name": "Path 28190",
    d: "M.059,6.539A17.124,17.124,0,0,0,.677,0H0Q.03,3.27.059,6.539",
    transform: "translate(26.053 47.723)",
    fill: "#e3fbfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28191",
    "data-name": "Path 28191",
    d: "M5.878.752C4.036-.552,1.967.267,0,.127A14.471,14.471,0,0,0,5.878.752",
    transform: "translate(49.453 55.927)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28192",
    "data-name": "Path 28192",
    d: "M.2.712l5.9-.067A16.176,16.176,0,0,0,.209,0C.025.157-.038.314.022.473S.143.712.2.712",
    transform: "translate(60.206 55.899)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28193",
    "data-name": "Path 28193",
    d: "M2.16.745,5.351.724C3.687-.572,1.789.3,0,.142l2.16.6",
    transform: "translate(55.697 48.925)",
    fill: "#e3fbfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28194",
    "data-name": "Path 28194",
    d: "M2.276,0C3.467,2.989.911,1.436,0,1.878a1.9,1.9,0,0,0,2.82.144C3.476,1.371,3.333.444,2.276,0",
    transform: "translate(72.498 63.041)",
    fill: "#e3fafe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28195",
    "data-name": "Path 28195",
    d: "M0,.138C1.725.85,3.547.7,5.349.736,3.691-.582,1.786.307,0,.138",
    transform: "translate(29.62 45.744)",
    fill: "#e3fbfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28196",
    "data-name": "Path 28196",
    d: "M5.2.711C3.589-.54,1.738.276,0,.112c1.669.764,3.444.6,5.2.6",
    transform: "translate(57.116 50.834)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28197",
    "data-name": "Path 28197",
    d: "M0,1.113c1.044-.184,2.252.431,3.113-.64C2.061.612.641-1.035,0,1.113",
    transform: "translate(43.943 59.958)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28198",
    "data-name": "Path 28198",
    d: "M4.558.818,4.564.107,4.315,0l-.26.074Q3.877.185,3.7.3C2.609.859,1.371.226.269.713A1.539,1.539,0,0,0,0,.937a9.64,9.64,0,0,0,4.556.509c0-.209,0-.419,0-.629",
    transform: "translate(55.852 55.793)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28199",
    "data-name": "Path 28199",
    d: "M0,.024C1.418,1.18,3.053.6,4.616.6A9.617,9.617,0,0,0,0,.024",
    transform: "translate(67.401 56.586)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28200",
    "data-name": "Path 28200",
    d: "M0,.606C1.461.6,3.013,1.357,4.328.1L4.073,0,3.808.067C2.569.459,1.168-.29,0,.606",
    transform: "translate(101.91 60.934)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28201",
    "data-name": "Path 28201",
    d: "M4.581.569A4.858,4.858,0,0,0,4.55,0L0,.026C1.456.8,3.029.592,4.581.569",
    transform: "translate(102.902 56.038)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28202",
    "data-name": "Path 28202",
    d: "M4.731.592A10.564,10.564,0,0,0,0,.018C1.45,1.261,3.148.447,4.731.592",
    transform: "translate(61.04 63.601)",
    fill: "#e3fafe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28203",
    "data-name": "Path 28203",
    d: "M4.679.565A10.941,10.941,0,0,0,0,.008c1.439,1.2,3.114.418,4.679.557",
    transform: "translate(66.771 64.268)",
    fill: "#e3fafe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28204",
    "data-name": "Path 28204",
    d: "M0,.062c1.418,1.125,3.044.5,4.591.545C3.131-.167,1.56-.006,0,.062",
    transform: "translate(45.776 76.949)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28205",
    "data-name": "Path 28205",
    d: "M0,.119A10.306,10.306,0,0,0,4.645.682C3.22-.519,1.554.262,0,.119",
    transform: "translate(55.759 77.566)",
    fill: "#e3fafe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28206",
    "data-name": "Path 28206",
    d: "M0,.126C1.5.849,3.105.644,4.685.673,3.24-.514,1.568.26,0,.126",
    transform: "translate(61.442 78.202)",
    fill: "#e3fafe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28207",
    "data-name": "Path 28207",
    d: "M4.68.687C3.234-.48,1.575.2,0,.154A10.076,10.076,0,0,0,4.68.687",
    transform: "translate(63.365 51.477)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28208",
    "data-name": "Path 28208",
    d: "M0,.123A11.6,11.6,0,0,0,4.682.711C3.253-.541,1.566.274,0,.123",
    transform: "translate(67.18 78.837)",
    fill: "#e3fafe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28209",
    "data-name": "Path 28209",
    d: "M0,1.306q.009.619.018,1.238C1.555,1.97,1.673,1.112.528,0,.579.528.695,1.081,0,1.306",
    transform: "translate(40.793 47.724)",
    fill: "#e3fbfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28210",
    "data-name": "Path 28210",
    d: "M0,.125A10.638,10.638,0,0,0,4.7.7C3.258-.533,1.571.27,0,.125",
    transform: "translate(49.985 48.301)",
    fill: "#e3fbfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28211",
    "data-name": "Path 28211",
    d: "M0,1C1.191.222,2.512.915,3.75.669,2.422-.1,1.13-.462,0,1",
    transform: "translate(44.552 47.621)",
    fill: "#e3fbfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28212",
    "data-name": "Path 28212",
    d: "M4,.52A8.63,8.63,0,0,0,0,.007C1.219,1.066,2.658.421,4,.52",
    transform: "translate(75.053 59.228)",
    fill: "#e3fafe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28213",
    "data-name": "Path 28213",
    d: "M3.406.064,0,.375c1.878.443,2.977.743,3.934-.254L3.68,0Z",
    transform: "translate(96.573 60.305)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28214",
    "data-name": "Path 28214",
    d: "M4.039.645C2.8-.416,1.367.151,0,.153A7.893,7.893,0,0,0,4.039.645",
    transform: "translate(61.458 57.214)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28215",
    "data-name": "Path 28215",
    d: "M0,.106A8.171,8.171,0,0,0,4.005.622C2.785-.445,1.344.206,0,.106",
    transform: "translate(78.016 80.124)",
    fill: "#e3fafe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28216",
    "data-name": "Path 28216",
    d: "M0,.1A8.182,8.182,0,0,0,3.969.591C2.752-.423,1.331.2,0,.1",
    transform: "translate(72.32 79.49)",
    fill: "#e3fafe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28217",
    "data-name": "Path 28217",
    d: "M4.013.645C2.787-.41,1.358.149,0,.138A8.321,8.321,0,0,0,4.013.645",
    transform: "translate(69.114 52.119)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28218",
    "data-name": "Path 28218",
    d: "M0,.046C1.249,1.091,2.691.512,4.063.529A8.046,8.046,0,0,0,0,.046",
    transform: "translate(50.231 54.732)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28219",
    "data-name": "Path 28219",
    d: "M0,.06c1.036.9,2.24.5,3.4.439A6.1,6.1,0,0,0,0,.06",
    transform: "translate(45.145 54.116)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28220",
    "data-name": "Path 28220",
    d: "M3.4.605C2.373-.334,1.163.084,0,.146a6.37,6.37,0,0,0,3.4.46",
    transform: "translate(67.182 57.858)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28221",
    "data-name": "Path 28221",
    d: "M2.534,23.051C1.913,34.62,1.379,46.195.084,57.717a41.071,41.071,0,0,0-.062,4.127c.948-.647.4-1.786.864-2.849,1.871,1.063,2.3,2.644,2.295,4.5-.017,3.815.007,7.63-.009,11.445-.006,1.509.291,3.19,2.119,2.66,1.547-.449,4.319.616,4.285-2.814-.111-11.02.427-22.069-.2-33.053C8.934,34,9.18,26.3,8.9,18.592c-.738-3.934-.343-7.909-.248-11.85C8.72,3.667,7.761,1.486,5.089.034a.856.856,0,0,0-.96.341C3.1,2.413,4,4.756,3.1,6.815c-1.334,4.656-.543,9.5-1.271,14.215a2.177,2.177,0,0,0,.708,2.021",
    transform: "translate(126.572 62.209)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28222",
    "data-name": "Path 28222",
    d: "M20.359,49.948c2.774,2.3,4.262,4.96,3.948,8.86-.252,3.142-.878,6.468.506,9.592.286-5.271-.548-10.574.431-15.827q.073-9.176.145-18.353c-.6-5.49-.15-11-.244-16.494-.081-4.769.013-9.542-.04-14.312-.011-1.007.435-2.127-.438-3.026l.094.1c-.608-.809-1.386-.405-2.124-.3C15.246.594,7.85.769.448.6L0,.979c1.5,1.226,3.26.536,4.89.593,3.262.113,6.542-.134,9.757.666,2.287-.859,4.564.007,6.845.052,1.069.022,1.378.782,1.4,1.732a78.542,78.542,0,0,1-1.146,14.085,41.592,41.592,0,0,0-.109,4.4,16.428,16.428,0,0,1-.594,4.951c-.384,5.367-.976,10.714-1.419,16.074-.179,2.164-.818,4.43.73,6.417",
    transform: "translate(110.653 12.401)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28223",
    "data-name": "Path 28223",
    d: "M.815,0C-.655,4.372.141,10.285,1.037,14.741",
    transform: "translate(135.406 84.295)",
    fill: "#e6fbfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28224",
    "data-name": "Path 28224",
    d: "M.667,0C-.5,1.357.26,2.976.059,4.464,1.247,3.11.443,1.485.667,0",
    transform: "translate(125.89 128.497)",
    fill: "#e6fbfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28225",
    "data-name": "Path 28225",
    d: "M.052,0C.256,1.667-.422,3.413.5,5.016.591,3.322.973,1.6.052,0",
    transform: "translate(151.968 101.791)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28226",
    "data-name": "Path 28226",
    d: "M7.857.914,6.806.834c-1.711-.678-3.612.327-5.3-.6L1.548.231A1.568,1.568,0,0,0,.37.034.755.755,0,0,0,0,.706c.127.445.562.565.865.825l1.053.106c1.294.554,2.737-.132,4.025.48C14.142,3.16,22.325,4.361,30.59,4.8c1.7.724,3.6-.316,5.271.611a.3.3,0,0,0,.441.029c1.786-.064,3.776,1.319,5.286-.738l-.214-.107-.228.073c-1.5-.635-3.167.2-4.655-.532l-1.582-.108c-1.12-.494-2.395.081-3.5-.5-6.267-.832-12.525-1.744-18.847-2.059-1.519-.6-3.206.244-4.7-.548",
    transform: "translate(55.727 130.143)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28227",
    "data-name": "Path 28227",
    d: "M0,1.057Q12.931,2.609,25.862,4.149c.685.081,1.648.43,1.923-.505.327-1.111-.736-1.117-1.4-1.175C19.527,1.876,12.746.566,5.853.368,3.873.349,1.76-.8,0,1.057",
    transform: "translate(63.589 146.545)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28228",
    "data-name": "Path 28228",
    d: "M5.285,0C3.683,1.389,1.735.295,0,.738l12.909,1.8c.831.022,1.661.059,2.492.06.661,0,1.652.446,1.681-.7C17.106.906,16.1.986,15.428.855,13.7.519,11.871.887,10.2.111L5.285,0",
    transform: "translate(92.03 134.841)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28229",
    "data-name": "Path 28229",
    d: "M5.091,1.905c1.822-1.323,3.924-.27,5.852-.689A49.641,49.641,0,0,0,0,0L.008.652c1.121.757,2.563-.191,4.233.92A3.624,3.624,0,0,0,.5,1.347a10.509,10.509,0,0,0,4.588.558",
    transform: "translate(58.497 145.697)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28230",
    "data-name": "Path 28230",
    d: "M10.148.719,9.94.613,9.71.658C8.419.118,6.985.8,5.7.192L3.374,0C2.271.325,1-.268,0,.617c1.328,1.126,3.1-.186,4.448.805a.39.39,0,0,0,.457.046c1.063.542,2.307-.127,3.358.5l2.49.151L11,1.9a.978.978,0,0,0-.046-.637,4.517,4.517,0,0,1-.806-.547",
    transform: "translate(41.342 129.038)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28231",
    "data-name": "Path 28231",
    d: "M5.284.8C3.981-.456,2.282.47.836,0L0,.227A11.18,11.18,0,0,0,5.284.8",
    transform: "translate(40.505 129.656)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28232",
    "data-name": "Path 28232",
    d: "M5.27.743C3.641-.556,1.764.274,0,.132A12.006,12.006,0,0,0,5.27.743",
    transform: "translate(86.318 134.808)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28233",
    "data-name": "Path 28233",
    d: "M.5.695,3.628.5c.013-.166.027-.332.041-.5H0Q0,.317,0,.634A.451.451,0,0,0,.5.695",
    transform: "translate(58.502 146.349)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28234",
    "data-name": "Path 28234",
    d: "M4.5,1.255,3.82.6A3.584,3.584,0,0,0,.106.438.661.661,0,0,0,0,.738c1.44.685,2.982.495,4.5.517",
    transform: "translate(52.095 130.419)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28235",
    "data-name": "Path 28235",
    d: "M4.025.619C2.787-.407,1.359.156,0,.138a9.089,9.089,0,0,0,4.025.48",
    transform: "translate(57.645 131.641)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28236",
    "data-name": "Path 28236",
    d: "M3.358.638c-1-.966-2.2-.566-3.358-.5a5.5,5.5,0,0,0,3.358.5",
    transform: "translate(46.247 130.367)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28237",
    "data-name": "Path 28237",
    d: "M4.456,34.331Q5.1,22.887,5.746,11.442c.8-1.407-.215-3.063.614-4.466q.01-2.22.02-4.44C6.616,1.579,7.43.478,5.747,0L5.728,1.249c-.728.964.136,2.233-.612,3.192-.255,7.348-1.569,14.582-2.329,21.876-.521,5-.964,10.017-1.515,15.018C.944,44.319.987,47.36.018,50.254Q.009,52.782,0,55.309c.081,1.5-.385,3.2,1.463,4.065.772-.535.179-1.713,1.086-2.131q.647-8.274,1.3-16.548c.83-2.06-.273-4.307.614-6.362Z",
    transform: "translate(126.557 28.018)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28238",
    "data-name": "Path 28238",
    d: "M.746.038C-.17.86-.01,1.938.05,2.989.711,14.681,1.394,26.372,2.017,38.067c.09,1.688.359,2.961,2.466,2.74,1.315-.138,1.666-.859,1.585-2.068-.118-1.779-.275-3.561-.377-5.346q-.354-6.21-.709-12.419C4.648,15.093,4.051,9.243,3.944,3.357,3.9.976,3.25-.234.746.038",
    transform: "translate(173.644 118.988)",
    fill: "#ebfaf6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28239",
    "data-name": "Path 28239",
    d: "M32.924,2.642l-11.734-.8a2.233,2.233,0,0,1-.71.445,3.386,3.386,0,0,0,.719-.434A126.433,126.433,0,0,0,5.188,0C6.35,2.222,5.93,3.417,3.171,3.215,2.121,3.138,1.057,3.233,0,3.25.278,4.767,1.569,4.384,2.515,4.527c4.772.722,9.584,1.118,14.374,1.69a7.042,7.042,0,0,0,1.587.158,34.27,34.27,0,0,1,4.643.566c.54.064,1.082.066,1.625.076,7.818.823,15.623,1.737,23.434,2.6,1.375.152,2.715.4,3.892-.6,2.587.361,3.264-1.564,4.039-3.374-.6-1.785-2.233-1.287-3.448-1.431-4.477-.532-8.963-.979-13.441-1.5a5.027,5.027,0,0,0-1.61-.072,9.82,9.82,0,0,1-4.687,0",
    transform: "translate(59.031 80.782)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28240",
    "data-name": "Path 28240",
    d: "M4.481,14.019H8.969c.764-.694,1.962.2,2.662-.725a.833.833,0,0,0-.347-.832,17.315,17.315,0,0,0-5.755-1.1C3.612,11.255,2.6,10.534,2.807,8.52c.045-.46.045-.921.045-1.38.482-1.415-.081-3.5,1.742-4.064,2.362-.73,4.766.171,7.08.747.922.229.82,1.361.759,2.2a34.884,34.884,0,0,1-.767,4.012c-.109,1.263.283,2.193,1.648,2.471a1.4,1.4,0,0,0,1.141-.719c.274-2.728.493-5.462.843-8.181.2-1.538-.12-2.317-1.876-2.441C9.951.918,6.485.529,3.04.044,1.436-.182,1.009.462.917,1.875.794,3.767.583,5.657.336,7.538c-.7,5.353-.717,5.351,4.145,6.481",
    transform: "translate(22.857 75.013)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28241",
    "data-name": "Path 28241",
    d: "M26.969,2.82C19.083,1.982,11.2,1.11,3.308.339,2.174.228.112-.553.007.717-.142,2.528,2.055,1.9,3.23,2.036,11.741,3.05,20.267,3.939,28.784,4.9c1.181.134,2.462.635,2.2-1.4-1.223-.918-2.753-.016-4.019-.678",
    transform: "translate(41.478 88.23)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28242",
    "data-name": "Path 28242",
    d: "M34.638,3.794,17.179,1.4,12.44,1.27c-1.93-.693-4.05.367-5.946-.638l.036.029C4.659-.1,2.569,1.044.73,0,.074.088-.177.631.131,1.035c.544.713,1.436.471,2.22.415,1.116.463,2.364-.075,3.47.463L31.279,5.125l4.985.092a.879.879,0,0,0,.915.108c1.03-.393,2.354.265,3.173-.886a11.342,11.342,0,0,0-4.613-.534c-.617.6-1.437.146-2.119.411.293-.265.837-.04,1.019-.521",
    transform: "translate(41.852 82.626)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28243",
    "data-name": "Path 28243",
    d: "M4.757.738,0,.884C.408,2.531,1.848,1.943,2.84,2.078c3.139.425,6.3.684,9.452,1.007C13.286.646,11.034.947,9.928.274,8.17.036,6.394-.373,4.757.738",
    transform: "translate(26.018 57.659)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28244",
    "data-name": "Path 28244",
    d: "M2.272,4.224c1.273-.462,2.863-.743,2.744-2.747C4.968.679,4-.286,3.778.08,2.862,1.6.042-.581,0,2.144c-.021,1.427.712,2.136,2.271,2.08",
    transform: "translate(38.794 63.178)",
    fill: "#e7fafd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28245",
    "data-name": "Path 28245",
    d: "M.04,1.557c.848.46,2.32.323,1.909,1.991a3.76,3.76,0,0,0,.78.517c.85.3,1,2.308,2.386,1.135,1.153-.975.017-1.842-.422-2.726A15.009,15.009,0,0,1,4.069.72Q3.261.362,2.455,0C2.059,1.2,1.1.1.5.479A.931.931,0,0,0,.04,1.557",
    transform: "translate(36.359 57.194)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28246",
    "data-name": "Path 28246",
    d: "M3.148,0,2.667.434C1.8,1.217,1.114.148.317.193A.632.632,0,0,0,.018.9l.3.58A1.176,1.176,0,0,0,.954,2.809l.522.712c.58,1,1.172,1.97,2.593,1.359C5.725,2.882,3.059,1.7,3.148,0",
    transform: "translate(34.163 86.799)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28247",
    "data-name": "Path 28247",
    d: "M0,.023C1.8,1.417,3.861.516,5.8.684,3.94-.178,1.96.017,0,.023",
    transform: "translate(42.582 82.604)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28248",
    "data-name": "Path 28248",
    d: "M0,.023C1.855,1.414,3.953.532,5.946.661A14.9,14.9,0,0,0,0,.023",
    transform: "translate(48.346 83.235)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28249",
    "data-name": "Path 28249",
    d: "M0,.153.454.6c.5.694,1.247.316,1.884.417,1-.116,2.044.276,3-.3C3.671-.558,1.784.284,0,.153",
    transform: "translate(67.796 106.814)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28250",
    "data-name": "Path 28250",
    d: "M2.6,1.358C1.426,1.493.9.393,0,0-.082,1.847,1.133,1.971,2.5,1.872c.073-.005.175-.139.19-.225s-.059-.192-.094-.289",
    transform: "translate(35.634 90.32)",
    fill: "#f0fcfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28251",
    "data-name": "Path 28251",
    d: "M0,.062C1.438,1.141,3.059.571,4.617.576A9.143,9.143,0,0,0,0,.062",
    transform: "translate(24.146 102.395)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28252",
    "data-name": "Path 28252",
    d: "M3.292,1.326C3.22.817,3.245.262,2.656,0,1.8.346.705-.136,0,.749l2.557.637.735-.06",
    transform: "translate(31.826 88.281)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28253",
    "data-name": "Path 28253",
    d: "M0,.124,4.019.8C2.873-.573,1.353.27,0,.124",
    transform: "translate(68.446 90.927)",
    fill: "#e6fbfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28254",
    "data-name": "Path 28254",
    d: "M3.417,0,.227.035c-.2.13-.269.262-.2.393s.132.2.2.2L4.35.52A3.852,3.852,0,0,1,3.934.05L3.667.115Z",
    transform: "translate(69.712 107.532)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28255",
    "data-name": "Path 28255",
    d: "M3.985.621C2.76-.391,1.349.137,0,.142A7.845,7.845,0,0,0,3.985.621",
    transform: "translate(45.602 78.196)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28256",
    "data-name": "Path 28256",
    d: "M3.469.592C2.42-.366,1.178.125,0,.13A6.347,6.347,0,0,0,3.469.592",
    transform: "translate(44.205 83.947)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28257",
    "data-name": "Path 28257",
    d: "M2.986.769c-1,.4-2.817-.549-2.975.8C-.14,2.866,1.274,3.827,2.752,4.035a1.645,1.645,0,0,1,1.313.7L23.784,7.3a6.334,6.334,0,0,0,3.612.038c1.317-.132,3.133.041,3.038-1.8-.077-1.489-1.774-1.279-2.98-1.506-2.488-.469-5.118-.143-7.477-1.318-.02-.815-.6-1.036-1.25-1.128C14.27.943,9.79.5,5.315.02a2.843,2.843,0,0,0-2.329.75",
    transform: "translate(70.984 121.284)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28258",
    "data-name": "Path 28258",
    d: "M6.064,1.888a155.388,155.388,0,0,1,16.99,1.937L39.577,5.187c1.125-.845,2.649.652,3.7-.632-1.538-1.027-3.273-.649-4.948-.7-.781.759-1.84.073-2.681.516-.422.041.076-.706-.005-.29.764.087,1.563.424,2.217-.3a8.7,8.7,0,0,0-4.015-.494c-1.128.67-2.321.057-2.929.228-.97-.1-.507-.692-.584-.275-.029.157.031.232.177.251.592.079,1.2.234,1.652-.345C22.847,1.762,13.507.638,4.113,0l-1,.2C2.149.778.916-.056,0,.789l6.064,1.1",
    transform: "translate(67.907 120.165)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28259",
    "data-name": "Path 28259",
    d: "M.92.493,0,.656a17.989,17.989,0,0,0,6.347.673C6.954.743,7.733.988,8.587.868c-.829.2-1.625-.144-2.217.466Q19.188,2.9,32.006,4.468c1.035.129,2.058.352,3.087.531,1.1-.469,3.162.9,3.266-.634.125-1.859-2.091-.9-3.243-1.277a19.548,19.548,0,0,0-2.13-.468C25.088,1.8,17.192.969,9.293.175,7.93.038,6.551.054,5.179,0,3.827.748,2.294-.062.92.493",
    transform: "translate(78.117 87.188)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28260",
    "data-name": "Path 28260",
    d: "M6.752.259.22.35,0,.634.228.91Q16.416,2.8,32.6,4.7a3.341,3.341,0,0,0,.631.037c.766-.054,1.948.476,2.014-.778.052-.977-1.074-.788-1.749-.869-2.619-.317-5.249-.549-7.868-.871-4.7-.579-9.393-1.2-14.09-1.8L10.387.3A6.081,6.081,0,0,0,6.752.259",
    transform: "translate(76.726 115.443)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28261",
    "data-name": "Path 28261",
    d: "M5.872,0C4.038,1.295,1.934.248,0,.68L6.517,1.827c2.733.225,5.463.49,8.2.647.7.04,1.892.67,1.974-.715.059-1-.969-.948-1.671-1.01C11.971.479,8.921.246,5.872,0",
    transform: "translate(93.97 129.168)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28262",
    "data-name": "Path 28262",
    d: "M0,.8a1.7,1.7,0,0,1,.259.426c3.011.251,6.02.526,9.033.737.64.045,1.66.42,1.717-.69C11.059.3,10.067.29,9.383.223,8.038.09,6.682.068,5.33,0,3.593.534,1.6-.673,0,.8",
    transform: "translate(75.452 108.732)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28263",
    "data-name": "Path 28263",
    d: "M5.667,1.413c1.745-.478,3.728.63,5.33-.8A16.972,16.972,0,0,0,5.256.024C3.658,1.389,1.723.291,0,.74c1.821.794,3.76.6,5.667.673",
    transform: "translate(69.785 108.119)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28264",
    "data-name": "Path 28264",
    d: "M3.7.017C2.476.284,1.072-.5,0,.65,1.254.56,2.8,2.185,3.7.017",
    transform: "translate(107.483 124.703)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28265",
    "data-name": "Path 28265",
    d: "M5.076.735A4.825,4.825,0,0,0,0,.707L1.607.823A5.151,5.151,0,0,0,5.076.735Z",
    transform: "translate(71.871 115.058)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28266",
    "data-name": "Path 28266",
    d: "M2.067,0,0,.246c1.285.5,2.56.946,3.752-.106L2.067,0",
    transform: "translate(97.997 123.313)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28267",
    "data-name": "Path 28267",
    d: "M3.612.038,0,0C1.23,1.046,2.66.456,4.013.488a2.017,2.017,0,0,1-.4-.45",
    transform: "translate(94.768 128.581)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28268",
    "data-name": "Path 28268",
    d: "M3.406.054,0,.378C1.814.832,2.894,1.133,3.876.13L3.656,0Z",
    transform: "translate(102.358 123.893)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28269",
    "data-name": "Path 28269",
    d: "M3.468,0,0,.089A6.622,6.622,0,0,0,3.475.561c0-.187-.006-.374-.007-.561",
    transform: "translate(73.479 115.793)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28270",
    "data-name": "Path 28270",
    d: "M0,.028C1.247,1.121,2.712.482,4.09.543A8.819,8.819,0,0,0,0,.028",
    transform: "translate(55.959 112.624)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28271",
    "data-name": "Path 28271",
    d: "M.359.59,3.994.628C2.779-.441,1.343.2,0,.112L.359.59",
    transform: "translate(83.119 115.112)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28272",
    "data-name": "Path 28272",
    d: "M0,.032.668.739A7.172,7.172,0,0,0,4.388.861l1.4-.21A13.734,13.734,0,0,0,0,.032",
    transform: "translate(51.489 129.724)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28273",
    "data-name": "Path 28273",
    d: "M0,.034c1.64,1.3,3.517.5,5.294.6A12.148,12.148,0,0,0,0,.034",
    transform: "translate(57.238 130.347)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28274",
    "data-name": "Path 28274",
    d: "M0,.027C1.439,1.18,3.093.457,4.654.559A10.827,10.827,0,0,0,0,.027",
    transform: "translate(92.218 134.249)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28275",
    "data-name": "Path 28275",
    d: "M0,.052C1.451,1.223,3.117.555,4.7.6A9.436,9.436,0,0,0,0,.052",
    transform: "translate(63.584 131.005)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28276",
    "data-name": "Path 28276",
    d: "M0,.073c1.237,1,2.648.513,4.008.466A7.214,7.214,0,0,0,0,.073",
    transform: "translate(47.043 129.157)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28277",
    "data-name": "Path 28277",
    d: "M0,.034c1.048,1,2.317.454,3.5.5A6.494,6.494,0,0,0,0,.034",
    transform: "translate(87.134 133.63)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28278",
    "data-name": "Path 28278",
    d: "M1.115.741c1.006-.379,2.22.353,3.118-.587C2.81.225,1.3-.474,0,.629L1.115.741",
    transform: "translate(66.792 120.213)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28279",
    "data-name": "Path 28279",
    d: "M.016.7,2.937.438C1.7-.181.794-.186,0,.7L.016.7",
    transform: "translate(62.209 119.627)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28280",
    "data-name": "Path 28280",
    d: "M3.761.746q.012-.3,0-.592L2.075,0,0,.269,0,.746Z",
    transform: "translate(66.176 107.413)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28281",
    "data-name": "Path 28281",
    d: "M9.522.671,0,0C.365.365.717,1.03,1.1,1.048c2.885.135,5.691.228,8.006,2.441.718.686,1.975.372,3.02-.095a11.8,11.8,0,0,1,9.439-.055c3.027,1.181,6.247.2,9.394.933,3.344.774,6.911.584,10.381.815l.017-.017a.585.585,0,0,0-.039-.8c-.88-.3-1.854.062-2.712-.389L36.88,3.753c-1.072-.577-2.318.034-3.4-.5l-2.329-.148c-1.3-.39-2.7-.357-3.977-.845-1.363-.123-2.735.073-4.1-.125A105.516,105.516,0,0,1,9.522.671",
    transform: "translate(69.315 8.293)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28282",
    "data-name": "Path 28282",
    d: "M0,0Q.173,15.045.357,30.09c.017,1.25-.237,2.541.365,3.741Q.755,18.024.781,2.216C.782,1.4.972.486,0,0",
    transform: "translate(135.32 12.79)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28283",
    "data-name": "Path 28283",
    d: "M0,.511c0,.176.006.352.011.528C7.643.891,15.286,1.5,22.908.71c-2.714-1.2-5.5-.579-8.267-.309A73.84,73.84,0,0,1,3.169.4,3.247,3.247,0,0,0,0,.511",
    transform: "translate(110.66 12.325)",
    fill: "#cdeaed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28284",
    "data-name": "Path 28284",
    d: "M0,.789,8.267,1.1,10.112.957C6.764-.429,3.388-.152,0,.789",
    transform: "translate(125.301 11.937)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28285",
    "data-name": "Path 28285",
    d: "M0,.223A9.6,9.6,0,0,0,4.072.668,1.97,1.97,0,0,0,6.2.582C6.189.388,6.176.193,6.161,0L0,.223",
    transform: "translate(92.397 10.208)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28286",
    "data-name": "Path 28286",
    d: "M2.74.8,5.909.7C4.037-.533,1.975.267,0,.141L2.74.8",
    transform: "translate(107.92 12.032)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28287",
    "data-name": "Path 28287",
    d: "M2.128,0,0,.086A7.494,7.494,0,0,0,4,.612C3.534-.078,2.8.061,2.128,0",
    transform: "translate(96.471 10.791)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28288",
    "data-name": "Path 28288",
    d: "M0,.124a5.292,5.292,0,0,0,3.4.5c-1.01-1-2.241-.486-3.4-.5",
    transform: "translate(102.799 11.426)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28289",
    "data-name": "Path 28289",
    d: "M5.074.1C3.379.258,1.58-.508,0,.673,1.689.46,3.494,1.28,5.074.1",
    transform: "translate(66.763 5.041)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28290",
    "data-name": "Path 28290",
    d: "M7,14.094c.925.667.519,1.667.633,2.537A68.433,68.433,0,0,0,8.856,1.4C8.828.692,8.44.107,7.711.154,5.14.32,2.486-.586,0,.715,9.319,1.07,7.842,1.2,7.284,9.7q-.144,2.2-.28,4.4",
    transform: "translate(125.3 13.923)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28291",
    "data-name": "Path 28291",
    d: "M.037,3.192C1.069,2.287.518,1.078.65,0-.387.9.159,2.112.037,3.192",
    transform: "translate(131.635 29.267)",
    fill: "#cdeaed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28292",
    "data-name": "Path 28292",
    d: "M0,.808a11.5,11.5,0,0,0,4.718.548c1.093-.656,2.255-.123,2.7-.232a1.587,1.587,0,0,0-1.629.348L23.186,3.818c.712-.253,1.862.46,2.107-.768.225-1.128-.789-1.031-1.467-1.1Q13.978.956,4.127,0C2.96,1.336,1.356.437,0,.808",
    transform: "translate(91.955 82.616)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28293",
    "data-name": "Path 28293",
    d: "M.535.729,3.647.51C2.41.127,1.163-.488,0,.667A.589.589,0,0,0,.535.729",
    transform: "translate(106.822 61.716)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28294",
    "data-name": "Path 28294",
    d: "M9.854,7.911c.974-.9.2-2.349,1.03-3.3q.087-1.517.175-3.033c-.471-.7-.906-1.28-1.966-1.2A23.763,23.763,0,0,1,5.035.207C.166-.282.168-.3,0,4.756c.181.122.43.264.572.168,3.635-2.481,6.05-1.17,7.814,2.426.235.479.706,1.1,1.468.561",
    transform: "translate(28.448 48.062)",
    fill: "#e5f3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28295",
    "data-name": "Path 28295",
    d: "M8.547,5.84l.6-.871C7.436-.512,5.438-1.248.35,1.728c-1.009,2.53.264,3.5,2.572,3.757l5.625.354",
    transform: "translate(27.852 52.911)",
    fill: "#e8f5f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28296",
    "data-name": "Path 28296",
    d: "M.165,4.065c.208.031.486.163.614.076C5.054,1.215,6.909,4.509,8.96,7.3c.661-.084,1.737.937,1.816-.685L10.264,5.4a8.5,8.5,0,0,1-.789-.91c-3.6-5.538-3.6-5.54-9.063-2.245A1.628,1.628,0,0,0,.165,4.065",
    transform: "translate(28.038 50.575)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28297",
    "data-name": "Path 28297",
    d: "M0,.538c1.154-.075,2.4.6,3.437-.412C2.283.2,1.048-.413,0,.538",
    transform: "translate(56.121 55.968)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28298",
    "data-name": "Path 28298",
    d: "M.69,0C-.562,2.019.324,4.246.075,6.362,1.336,4.344.423,2.115.69,0",
    transform: "translate(130.326 62.35)",
    fill: "#def8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28299",
    "data-name": "Path 28299",
    d: "M.673,0C-.514,1.354.277,2.979.059,4.466,1.248,3.113.46,1.487.673,0",
    transform: "translate(132.243 34.995)",
    fill: "#cdeaed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28300",
    "data-name": "Path 28300",
    d: "M3.721.122,0,0A1.4,1.4,0,0,0,.045.4L3.759.559A1.149,1.149,0,0,0,3.721.122",
    transform: "translate(52.156 130.463)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28301",
    "data-name": "Path 28301",
    d: "M2.711.01,0,.187C1.053,1.573,1.94,1.377,2.7,0l.009.01",
    transform: "translate(77.518 82.626)",
    fill: "#ebfbfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28302",
    "data-name": "Path 28302",
    d: "M0,.615C1.431.547,2.95,1.246,4.259.122L3.167,0C2.149.4.911-.337,0,.615",
    transform: "translate(79.036 87.066)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28303",
    "data-name": "Path 28303",
    d: "M1.075.762,3.827.509C2.511.084,1.2-.444,0,.645L1.075.762",
    transform: "translate(96.672 83.327)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28304",
    "data-name": "Path 28304",
    d: "M2.156.3A2.083,2.083,0,0,0,0,.3,1.793,1.793,0,0,0,2.156.3",
    transform: "translate(71.707 84.61)",
    fill: "#ebfbfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28305",
    "data-name": "Path 28305",
    d: "M1.925,0,0,.378C1.387.821,2.257.992,3.026.111L1.925,0",
    transform: "translate(74.566 86.421)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28306",
    "data-name": "Path 28306",
    d: "M10.124,8.364a5.593,5.593,0,0,0,.552-1.417c.19-1.953,1.048-3.905.169-5.867-.181-.4-9.287-1.37-9.672-1C-.264,1.481.433,3.43,0,5.1c1.475.9,2.245-.5,3.206-1.067,1.431-.845,2.319-.614,3.437.66,1.1,1.257,1.188,3.554,3.482,3.675",
    transform: "translate(25.038 76.892)",
    fill: "#dee7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28307",
    "data-name": "Path 28307",
    d: "M9.557,6.127a3.308,3.308,0,0,0-.018-.456c-.314-1.855-1.818-3.015-2.7-4.542A2.176,2.176,0,0,0,3.809.29C2.669.833,1.509,1.312.329,1.75-.527,4.482.223,5.9,3.337,5.7c2.075-.134,4.11.773,6.22.425",
    transform: "translate(24.624 81.573)",
    fill: "#dde8ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28308",
    "data-name": "Path 28308",
    d: "M0,4.074c.88.873,1.757.529,2.509-.123,2.073-1.8,3.325-.873,4.3,1.193a7.6,7.6,0,0,0,2.4,2.85C10.1,7.889,11,9.962,11.878,7.984c-.839-.421-1.855-.691-1.671-1.976C9.5,5,8.812,3.982,8.092,2.986,5.346-.821,5.347-.812,1.445,2.018a10.566,10.566,0,0,1-1.361.72Q.042,3.406,0,4.074",
    transform: "translate(24.954 79.249)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28309",
    "data-name": "Path 28309",
    d: "M.022.7,2.958.442C1.7-.195.8-.173,0,.7L.022.7",
    transform: "translate(84.465 87.817)",
    fill: "#1d1d26"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/Book.a23f04345ebe7534c5fdc6cba5d2e54b.svg";
export { ForwardRef as ReactComponent };